<template>
    <header>
		<div class="preloader" v-if="loading">
			<div class="circular-spinner">
				<img src="../assets/images/shiba-loading.png" width="150">
			</div>
		</div>
		<nav class="x-header navbar navbar-expand -logged py-0">
			<div class="container-fluid align-items-center h-100 position-relative">
				<div id="headerBrand">
				<!-- <button
					type="button"
					class="btn bg-transparent p-0 x-hamburger js-hamburger-toggle"
					@click="gotoMain()"
				>
					<span></span>
					<span></span>
					<span></span>
				</button> -->
				<div class="-branding-inner-wrapper">
					<router-link to="/" class="navbar-brand">
					<img
						class="-logo"
						src="../assets/images/logo-headline65x400.png"
						alt="DeltaPlus รวมคาสิโนออนไลน์ บาคาร่าสด สล็อต กีฬา และเครดิตฟรี"
					/>
					</router-link>
				</div>
				</div>

				<div id="headerContent">
					<div class="paybridge-task-entrance" v-if="hasActivePayBridgeTask">
						<button
							type="button"
							class="paybridge-task-button"
							@click.stop="reopenPayBridgeTask()"
						>
							<span class="paybridge-task-dot"></span>
							<span class="paybridge-task-copy">
								<strong>PayBridge</strong>
								<small>{{ paybridgeAcknowledged ? 'รอสลิป' : 'ทำรายการต่อ' }} {{ paybridgeTaskRemainingText }}</small>
							</span>
						</button>
					</div>
					<div class="x-ranking-entrance">
							<router-link to="/rewards" class="-link-wrapper">
								<div class="-image-wrapper">
									<img class="img-fluid -ic-right-star-rank" src="../assets/images/coin1.png" alt="PUG888 แลกของรางวัล">
								</div>
								<div class="-text-wrapper">{{numberWithCommas2(user.coin)}}</div>
							</router-link>
					</div>
				<ul class="nav -menu-wrapper -logged">
					<li class="nav-item">
					<router-link to="/play" class="nav-link -partner">
						<div class="-img-wrapper">
						<img
							src="../assets/images/menu/play-1.png"
							class="-icon"
							alt="เข้าเล่น"
							width="60"
							height="60"
						/>
						</div>
						<div class="-text">เข้าเล่น</div>
					</router-link>
					</li>

					<li class="nav-item">
					<router-link to="/promotion" class="nav-link -partner">
						<div class="-img-wrapper">
						<img
							src="../assets/images/menu/promotion-1.png"
							class="-icon"
							alt="Promotion"
							width="60"
							height="60"
						/>
						</div>
						<div class="-text">โปรโมชั่น</div>
					</router-link>
					</li>

					<li class="nav-item">
					<router-link to="/partner" class="nav-link -partner">
						<div class="-img-wrapper">
						<img
							src="../assets/images/menu/friend-1.png"
							class="-icon"
							alt="Partner"
							width="60"
							height="60"
						/>
						</div>
						<div class="-text">พันธมิตร</div>
					</router-link>
					</li>

					<li class="nav-item">
					<router-link to="/cashback" class="nav-link -partner">
						<div class="-img-wrapper">
						<img
							src="../assets/images/menu/money-1.png"
							class="-icon"
							alt="Cashback"
							width="60"
							height="60"
						/>
						</div>
						<div class="-text">คืนยอด</div>
					</router-link>
					</li>
				</ul>

				<div class="navbar-nav">
					<div class="x-logged">
					<div class="-deposit-container d-none d-lg-block">
						<a
						href="#deposit"
						class="text-white js-account-approve-aware btn -btn-deposit"
						data-toggle="modal"
						data-target="#depositModal"
						@click="checkPromotions()"
						>
						<div class="f-7">ฝากเงิน</div>
						</a>
					</div>
					<div class="-withdraw-container d-none d-lg-block">
						<a
						href="#withdraw"
						class="text-white js-account-approve-aware btn -btn-withdraw"
						data-toggle="modal"
						data-target="#withdrawModal"
						@click="moveCreditToWallet()"
						>
						<div class="f-7">ถอนเงิน</div>
						</a>
					</div>
					<div class="-profile-container">
						<div class="d-none d-lg-block">
						<div class="-btn-wrapper">
							<div class="-inner-wrapper">
							<a
								href="#account"
								data-toggle="modal"
								data-target="#accountModal"
								class="text-decoration-none"
							>
								<div class="-profile-name2">{{user.code}}</div>
							</a>
							<div class="-balance-container">
								<div class="-text-username">
								{{user.code}}
								</div>

								<div class="-user-balance js-user-balance f-sm-6 f-7 ">
								<div class="-inner-box-wrapper2">
									<img
									class="img-fluid -ic-coin"
									src="../assets/images/shiba888-ic-coin.png"
									alt="customer image"
									width="26"
									height="21"
									/>

									<span id="customer-balance"
									><span class="-amount">{{ numberWithCommas(user.credit) }}</span>
									</span>
								</div>
								<button
									type="button"
									class="-btn-balance2"
									id="btn-customer-balance-reload"
									@click="reloadBalance()"
								>
									<i :class="{'fas':true, 'fa-sync-alt':true, 'f-10':true, 'fa-spin':fa_spin}"></i>
								</button>
								</div>
							</div>
							</div>

							<a
							href="#account"
							data-toggle="modal"
							data-target="#accountModal"
							>
							<div class="x-profile-image">
								<img
								class="img-fluid -profile-image"
								:src="getLevelImage()"
								alt="customer image"
								style="width:65px"
								/>
							</div>
							</a>
						</div>
						</div>

						<div class="d-lg-none">
						<div :class="{'js-ez-logged-sidebar':true, '-btn-mobile-wrapper':true , '-open':this.accountOpen }">
							<div class="-inner-wrapper" style="line-height:1;">
							<a href="javascript:void(0)" @click="showTabAccount()">
								<div class="-profile-name2">{{user.code}}</div>
							</a>
							<div class="-balance-container">
								<div class="-text-username">
								{{user.tel}}
								</div>

								<div class="-user-balance js-user-balance f-sm-6 f-7 ">
								<div class="-inner-box-wrapper2">
									<img
									class="img-fluid -ic-coin"
									src="../assets/images/shiba888-ic-coin.png"
									alt="customer image"
									width="26"
									height="21"
									/>

									<span id="customer-balance"
									><span class="-amount">{{ numberWithCommas(user.credit) }}</span>
									</span>
								</div>
								<button
									type="button"
									class="-btn-balance2"
									@click="reloadBalance()"
								>
									<i :class="{'fas':true, 'fa-sync-alt':true, 'f-10':true, 'fa-spin':fa_spin}"></i>
								</button>
								</div>
							</div>
							</div>

							<a href="javascript:void(0)" @click="showTabAccount()">
							<div class="x-profile-image">
								<img
								class="img-fluid -profile-image"
								:src="getLevelImage()"
								alt="customer image"
								style="width: 65px;"
								/>
							</div>
							</a>
						</div>

						<div :class="{'x-menu-account-list-sidebar':true,'-open':this.accountOpen}">
							<div class="x-modal-account-menu-mobile">
							<div class="-modal-profile-mobile d-xl-none d-block">
								<div class="text-right">
								<i class="fas fa-times f-5 js-close-account-sidebar" @click="showTabAccount()"></i>
								</div>

								<div class="x-profile-image">
								<img
									class="img-fluid"
									:src="getLevelImage2()"
									alt="customer image"
									style="width:120px;"
								/>
								</div>
								<div class="-balance-container">
								<div class="-text-username">
									<ul class="tags">
										<li><a href="#" class="tag" style="color:#999;">Level {{(user.level)?user.level:1}}</a></li>
									</ul>
								</div>
								<div class="-text-username">
									{{user.tel}}
								</div>

								<div
									class="-user-balance js-user-balance f-sm-6 f-7 "
								>
									<div class="-inner-box-wrapper2">
									<img
										class="img-fluid -ic-coin"
										src="../assets/images/shiba888-ic-coin.png"
										alt="customer image"
										width="26"
										height="21"
									/>

									<span id="customer-balance"
										><span class="-amount">{{numberWithCommas(user.credit)}}</span>
									</span>
									</div>
									<button
									type="button"
									class="-btn-balance2"
									@click="reloadBalance()"
									>
									<i :class="{'fas':true, 'fa-sync-alt':true, 'f-10':true, 'fa-spin':fa_spin}"></i>
									</button>
								</div>
								</div>
							</div>

							<div class="-lists-outer-wrapper">
								<ul class="navbar-nav">
								<!-- <li class="nav-item -join-promotion" v-if="!user.userId">
									<button
									type="button"
									class="nav-link js-close-account-sidebar "
									 @click="lineLogin()"
									>
									<img
										class="img-fluid -icon-image"
										src="../assets/images/icon-line.svg"
										alt="Line"
									/>
									<span class="-text-menu">เข้าสู่ระบบด้วยไลน์</span>
									</button>
								</li>	 -->
								<li class="nav-item -account-profile">
									<button
									type="button"
									class="nav-link js-close-account-sidebar "
									data-toggle="modal"
									data-target="#accountModalMobile"
									>
									<img
										class="img-fluid -icon-image"
										src="../assets/images/shiba888-ic-menu-user.png"
										alt="ic-menu-user"
									/>
									<span class="-text-menu">ข้อมูลบัญชี</span>
									</button>
								</li>
								<!-- <li class="nav-item -coupon">
									<button
									type="button"
									class="nav-link js-close-account-sidebar js-account-approve-aware"
									data-toggle="modal"
									data-target="#couponModalMobile"
									>
									<img
										class="img-fluid -icon-image"
										src="../assets/images/shiba888-ic-menu-coupon.png"
										alt="ic-menu-coupon"
									/>
									<span class="-text-menu">ใช้คูปอง</span>
									</button>
								</li> -->
								<li class="nav-item -join-promotion">
									<button
									type="button"
									class="nav-link js-close-account-sidebar "
									@click="$router.replace('/promotion')"
									>
									<img
										class="img-fluid -icon-image"
										src="../assets/images/shiba888-ic-menu-promotion.png"
										alt="ic-menu-promotion"
									/>
									<span class="-text-menu"
										>โปรโมชั่น</span
									>
									</button>
								</li>
								<li class="nav-item -logout">
									<a
									class="nav-link js-require-confirm"
									data-title="ต้องการออกจากระบบ ?"
									@click="confirmLogout()"
									>
									<img
										class="img-fluid -icon-image"
										src="../assets/images/shiba888-ic-menu-logout.png"
										alt="ic-menu-logout"
									/>
									<span class="-text-menu">ออกจากระบบ</span>
									</a>
								</li>
								</ul>
								<ul class="navbar-nav -action-nav">
								<li class="nav-item">
									<a
									href="https://lin.ee/rrSbqfG"
									class="nav-link js-close-account-sidebar"
									target="_blank"
									>
									<img
										src="../assets/images/btn_hover.png"
										class="-img"
										width="100"
										height="100"
										style="display: initial;"
									/>
									<div class="-text" style="font-size:12px;">ติดต่อแอดมิน</div>
									</a>
								</li>
								</ul>
							</div>
							</div>
							<div class="-overlay"></div>
						</div>
						</div>
					</div>
					</div>
				</div>
				</div>
			</div>
			</nav>
			


		<div class="x-modal modal" id="accountModal" tabindex="-1" role="dialog" data-loading-container=".modal-body" data-container="#accountModal" aria-hidden="true">
			<div class="modal-dialog -modal-size  -modal-big -modal-main-account" role="document" style="padding-top: 74.8012px;">
			<div class="modal-content -modal-content">
				<button type="button" class="close f-1 " data-dismiss="modal" aria-label="Close">
					<i class="fas fa-times"></i>
				</button>
				<div class="modal-body -modal-body" style="top: 0px;">
					<div class="x-modal-account-menu">
						<ul class="navbar-nav">
							<!-- <li class="nav-item -account-profile" v-if="!user.userId">
								<button type="button" class="nav-link js-close-account-sidebar" @click="lineLogin()">
									<img class="img-fluid -icon-image" src="../assets/images/icon-line.svg" alt="Line" width="28" height="27">
									<span class="-text-menu" style="font-size:15px">
										เข้าสู่ระบบด้วยไลน์
									</span>
								</button>
							</li> -->
							<li class="nav-item -account-profile active">
								<button type="button" class="nav-link js-close-account-sidebar" data-container="#accountModal" data-active-menu="-account-profile" data-loading="_onLoading_" data-target=".js-profile-account-modal">
									<img class="img-fluid -icon-image" src="../assets/images/shiba888-ic-menu-user.png" alt="icon user" width="28" height="27">
									<span class="-text-menu" style="font-size:15px">
										ข้อมูลบัญชี
									</span>
								</button>
							</li>
							<!-- <li class="nav-item -account-provider ">
								<button type="button" class="nav-link js-close-account-sidebar" data-container="#accountModal" data-active-menu="-account-provider" data-loading="_onLoading_" data-target=".js-profile-account-modal">
									<img class="img-fluid -icon-image" src="../assets/images/shiba888-ic-menu-provider.png" alt="icon phone" width="28" height="27">
									<span class="-text-menu">
										เข้าเล่นผ่านแอพ
									</span>
								</button>
							</li> -->
										<!-- <li class="nav-item -coupon ">
									<button type="button" class="nav-link js-close-account-sidebar js-account-approve-aware" data-container="#accountModal" data-active-menu="-coupon" data-loading="_onLoading_" data-target=".js-profile-account-modal">
										<img class="img-fluid -icon-image" src="../assets/images/shiba888-ic-menu-coupon.png" alt="icon coupon" width="28" height="27">
										<span class="-text-menu">
											ใช้คูปอง
										</span>
									</button>
								</li> -->
									<li class="nav-item -join-promotion ">
								<button type="button" class="nav-link js-close-account-sidebar" data-container="#accountModal" data-active-menu="-join-promotion" data-loading="_onLoading_" data-target=".js-profile-account-modal" @click="gotoPromotion()">
									<img class="img-fluid -icon-image" src="../assets/images/shiba888-ic-menu-promotion.png" alt="icon promotion" width="28" height="27">
									<span class="-text-menu" style="font-size:15px">
										โปรโมชั่น
									</span>
								</button>
							</li>

							
							<li class="nav-item js-close-account-sidebar -logout">
								<a href="javascript:void(0)" class="nav-link js-require-confirm" data-title="ต้องการออกจากระบบ ?" @click="confirmLogout()">
									<img class="img-fluid -icon-image" src="../assets/images/shiba888-ic-menu-logout.png" alt="icon logout" width="28" height="27">
									<span class="-text-menu" style="font-size:15px">
										ออกจากระบบ
									</span>
								</a>
							</li>
						</ul>
					</div>
					<div class="js-profile-account-modal -layout-account">
						<div class="x-account-profile -v2">
							<div data-animatable="fadeInModal" class="-profile-container animated fadeInModal">
							<div class="x-title-modal -v2 mx-auto text-center">
								ข้อมูลบัญชี
							</div>
				
							<div class="text-center">
								<div class="my-3">
									<div class="x-profile-image">
										<img class="img-fluid -profile-image" :src="getLevelImage2()" alt="customer image" style="width: 120px;">
									</div>
							</div>

							<div class="my-3">
								<div class="-text-username">Username:  {{user.tel}}</div>
									<a href="#0" class="-link-change-password" data-toggle="collapse" data-target=".js-change-password-collapse"><u style="color:#fff">เปลี่ยนรหัสผ่าน</u></a>
								</div>

								<div class="collapse -change-password-container js-change-password-collapse">
									<div class="js-collapse-content">

									<div class="form-group mt-3">
										<input type="password" v-model="password" required="required" placeholder="รหัสผ่านปัจจุบัน" class="x-form-control form-control">
									</div>
									<div class="form-group">
										<input type="password" v-model="password1" required="required" placeholder="รหัสผ่านใหม่" class="x-form-control form-control">
									</div>
									<div class="form-group">
										<input type="password" v-model="password2" required="required" placeholder="พิมพ์รหัสผ่านใหม่อีกครั้ง" class="x-form-control form-control">
									</div>

									<button type="button" @click="changePassword()" class="btn -submit btn-primary text-center m-auto js-user-confirm-deposit">
										<span>ยืนยัน</span>
									</button>

									</div>
								</div>
							</div>

							<div class="-bank-info-container">
								<div class="x-customer-bank-info-container -v2">
									<div class="media m-auto">
										<img v-if="user.bank" :src="require('../assets/images/bank/' + user.bank + '.jpg')" class="-img rounded-circle" width="50" height="50" alt="bank-scb">
										<div class="-content-wrapper">
											<span class="-name">{{user.firstname}} {{user.lastname}}</span>
											<span class="-number">{{user.account_no}}</span>
										</div>
									</div>
								</div>
							</div>

					
							<div class="x-admin-contact text-center ">
								<span class="x-text-with-link-component">
									<label class="-text-message ">พบปัญหา</label>
									<a href="https://lin.ee/rrSbqfG" class="-link-message " target="_blank" rel="noopener">
										<u>ติดต่อฝ่ายบริการลูกค้า</u>
									</a>
								</span>
							</div>

							<div class="js-has-info"></div>
						</div>
					</div>
				</div>
			</div>
			</div>
			</div>
		</div>


		<div class="x-modal modal show" id="accountModalMobile" tabindex="-1" role="dialog" data-loading-container=".modal-body" data-container="#accountModalMobile" aria-modal="true">
		<div class="modal-dialog -modal-size  -modal-mobile -account-modal -no-fixed-button" role="document" style="padding-top: 60px;">
			<div class="modal-content -modal-content">
				<button type="button" class="close f-1 " data-dismiss="modal" aria-label="Close">
					<i class="fas fa-times"></i>
				</button>
				<div class="modal-header -modal-header">
					<div class="x-modal-mobile-header">
						<div class="-header-mobile-container">
							<h3 class="x-title-modal mx-auto text-center d-inline-block">
								ข้อมูลบัญชี
							</h3>
						</div>
					</div>
				</div>
				<div class="modal-body -modal-body" style="top: 76px;">
					<div class="x-account-profile -v2">
						<div data-animatable="fadeInModal" class="-profile-container animated fadeInModal">
							<div class="text-center">
								<div class="my-3">
									<div class="x-profile-image">
										<img class="img-fluid -profile-image" :src="getLevelImage2()" alt="customer image">
									</div>
								</div>

								<div class="my-3">
									<div class="-text-username">Username:  {{user.tel}}</div>
									<a href="#0" class="-link-change-password" data-toggle="collapse" data-target=".js-change-password-collapse"><u style="color:#fff">เปลี่ยนรหัสผ่าน</u></a>
								</div>

								<div class="-change-password-container js-change-password-collapse collapse" style="">
									<div class="js-collapse-content">

											<div class="form-group mt-3">
												<input type="password" v-model="password" required="required" placeholder="รหัสผ่านปัจจุบัน" class="x-form-control form-control">
											</div>
											<div class="form-group">
												<input type="password" v-model="password1" required="required" placeholder="รหัสผ่านใหม่" class="x-form-control form-control">
											</div>
											<div class="form-group">
												<input type="password" v-model="password2" required="required" placeholder="พิมพ์รหัสผ่านใหม่อีกครั้ง" class="x-form-control form-control">
											</div>

											<button type="button" @click="changePassword()" class="btn btn-block -submit">
												<span>ยืนยัน</span>
											</button>
									</div>
								</div>
							</div>

							<div class="-bank-info-container">
								<div class="x-customer-bank-info-container -v2">
									<div class="media m-auto">
										<img v-if="user.bank" :src="require('../assets/images/bank/' + user.bank + '.jpg')" class="-img rounded-circle" width="50" height="50" alt="bank-scb">
										<div class="-content-wrapper">
											<span class="-name">{{user.firstname}} {{user.lastname}}</span>
											<span class="-number">{{user.account_no}}</span>
										</div>
									</div>
								</div>
							</div>
							<div class="x-admin-contact text-center ">
								<span class="x-text-with-link-component">
								<label class="-text-message ">พบปัญหา</label>
								<a href="https://lin.ee/rrSbqfG" class="-link-message " target="_blank" rel="noopener">
									<u>ติดต่อฝ่ายบริการลูกค้า</u>
								</a>
								</span>
							</div>

							<div class="js-has-info"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		</div>


		<div
			class="x-modal modal -v2 -with-half-size"
			id="withdrawModal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
			data-loading-container=".modal-body"
			data-container="#withdrawModal"
     	 >
<div class="modal-dialog -modal-size " role="document">
  <div class="modal-content -modal-content">
    <button
      type="button"
      class="close f-1 "
      data-dismiss="modal"
      aria-label="Close"
    >
      <i class="fas fa-times"></i>
    </button>
    <div class="modal-header -modal-header">
      <h3 class="x-title-modal -v2 m-auto">
ถอนเงิน
      </h3>
    </div>
    <div class="modal-body -modal-body" style="top: 0px;height: 350px;max-height: 350px;overflow-y: auto;">
      <div class="x-withdraw-form -v2">
  <div
    data-animatable="fadeInModal"
    class="-animatable-container animated fadeInModal"
  >
    <div class="text-center d-flex flex-column">
      <div
class="-x-input-icon x-input-operator mb-3 flex-column"
      >
<button
  type="button"
  class="-icon-left -btn-icon js-adjust-amount-by-operator"
  @click="setWithdraw('minus')"
>
  <i class="fas fa-minus-circle"></i>
</button>
<input
  type="text"
  v-model="withdraw"
  :class="{'x-form-control':true,'text-center':true, 'js-withdraw-input-amount':true ,'-no':true,'form-control':true,'is-invalid':(error)?true:false}"
  placeholder="จำนวนเงินที่ต้องการถอน"
  @keypress="isNumber($event)"

/>
						<div class="invalid-feedback " v-if="error">
							<ul class="list-unstyled mb-0"><li>{{error}}</li></ul>
						</div>
<button
  type="button"
  class="-icon-right -btn-icon js-adjust-amount-by-operator"
  @click="setWithdraw('plus')"
>
  <i class="fas fa-plus-circle"></i>
</button>
      </div>
					<!-- <div  v-if="lastbonus.canwithdraw || lastbonus.turncredit">
					<p class="glow" style="font-size:14px;">
						{{lastbonus.canwithdraw}}/{{lastbonus.turncredit}}
					</p>
					</div> -->
      <div
class="x-select-amount js-quick-amount -v2"
data-target-input="#withdraw_amount"
      >
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(200)"
  >
    <span class="-no" >200</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(300)"
  >
    <span class="-no" >300</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(500)"
  >
    <span class="-no" >500</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(1000)"
  >
    <span class="-no" >1000</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(2000)"
  >
    <span class="-no" >2000</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(5000)"
  >
    <span class="-no" >5000</span>
  </button>
</div>
      </div>
    </div>
	<!-- <div><p class="-title" style="font-family: 'Kanit', sans-serif; font-size: 12px; padding-bottom:10px;color:#fff">- ถอนขั้นต่ำ 100.- สูงสุด 100,000.- /ครั้ง</p></div>
	<div><p class="-title" style="font-family: 'Kanit', sans-serif; font-size: 12px; padding-bottom:10px;color:#fff">- สูงสุด 300,000.-และ 5 ครั้ง/วัน</p></div>
	<div><p class="-title" style="font-family: 'Kanit', sans-serif; font-size: 12px; padding-bottom:10px;color:#fff">- ระบบธนาคารปิดปรับปรุง โปรดเลี่ยงการแจ้งถอนในช่วงเวลา <br>23:50-00:10น.</p></div> -->
	<div class="mt-3 -spacer">
		<div class="x-deposit-bank-info-container -v2">
		<div class="media m-auto">
			<img
			v-if="user.bank" :src="require('../assets/images/bank/' + user.bank + '.jpg')"
			class="-img rounded-circle"
			width="50"
			height="50"
			alt="bank-bay"
			/>
			<div class="-content-wrapper">
			<span class="-own-name"
				>{{user.firstname}} {{user.lastname}}</span
			>
			<span id="depositBankNumber" class="-number"
				>{{user.account_no}}</span
			>
			</div>
			<div class="-copy-wrapper">
			<a
				href="javascript:void(0);"
				style="cursor: default;"
				class="btn -btn js-copy-to-clipboard"
				>เข้าบัญชีนี้</a
			>
			</div>
		</div>
		</div>
	</div>
    <div class="text-center">
      <button
type="button"
class="btn -submit btn-primary my-0 my-lg-3 f-5 f-lg-6"
						:disabled="withdrawSubmitting" @click="withdrawConfirm()"
      >
{{this.canwithdraw}}
      </button>
    </div>
  </div>

  <input
    type="hidden"
    id="withdraw__token"
    name="withdraw[_token]"
    value="bllExR5-OWRJU6oF0VySYE94ynEFuTfZGWIxep2iqUo"
  />
      </div>
    </div>
  </div>
</div>
      	</div>

		<div
			class="x-modal modal -v2 -with-backdrop -with-separator -with-half-size"
			id="depositModal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
			data-loading-container=".modal-body"
			data-container="#depositModal"
      >
<div class="modal-dialog -modal-size " role="document">
  <div class="modal-content -modal-content">
    <div class="modal-content -modal-content" :class="{'paybridge-modal-shell': paybridgeMatch}">
      <input type="file" id="my_file" accept="image/*" @change="uploadSlip">
      <button
		type="button"
		class="close f-1 "
		data-dismiss="modal"
		aria-label="Close"
      >
<i class="fas fa-times"></i>
      </button>
      <div class="modal-body -modal-body" style="top: 0px;">
<div class="x-pending -v2 ">
  <div
    class="js-content text-center -animated-wrapper animated fadeInModal"
    data-animatable="fadeInModal"
  >
    <div class="-fake-bg-top-wrapper">
      <h3
class="x-title-modal -v2 mx-auto text-center d-inline-block"
      >
ฝากเงิน
      </h3>
    </div>
    <div class="-fake-bg-bottom-wrapper">
      <div class="x-modal-separator-container ">
<div class="-top " v-if="!corepaypage">
	<div class="mt-3 -spacer" v-if="isCorepayEnabled() && user.bank !== 'truewallet'">
		<div class="x-deposit-bank-info-container -v2">
		<div class="media m-auto" @click="showCorepayPage()">
			<img
			src="https://play-lh.googleusercontent.com/UIdkgBTFEFYTbE-_hUnekG5Aq16au9J7C6RI5gnoAeEZV2zMC3XgOnjL-0aYdmyWk6k=w240-h480-rw"
			class="-img rounded-circle"
			width="50"
			height="50"
			alt="bank-bay"
			/>
			<div class="-content-wrapper">
					<span class="-name" style="font-size: large;">{{ paybridge && !paybridgeFallback ? 'ฝากผ่าน PayBridge' : 'ฝากผ่าน CorePay' }}</span>
				<span class="-own-name" v-if="paybridge && !paybridgeFallback">กรอกยอดก่อน เพื่อรับบัญชีปลายทางจาก PayBridge</span>
			</div>
			<div class="-copy-wrapper">
			<a
				href="javascript:void(0);"
				class="btn -btn js-copy-to-clipboard"
				style="padding: 10px;"
				>Click</a
			>
			</div>
		</div>
		</div>
	</div>
	<div class="mt-3 -spacer" v-if="bank.kbank && bank.kbank.accountno && user && user.bank !== 'truewallet' && bank.bank && shouldUseStandardDepositBanks()">
				<div class="x-deposit-bank-info-container -v2">
				<div class="media m-auto">
					<img
					src="../assets/images/bank/kbank.jpg"
					class="-img rounded-circle"
					width="50"
					height="50"
					alt="bank-bay"
					/>
					<div class="-content-wrapper">
					<span class="-name">ธนาคารกสิกร</span>
					<span class="-own-name"
						>{{bank.kbank.firstname}} {{bank.kbank.lastname}}</span
					>
					<span id="depositBankNumber" class="-number"
						>{{bank.kbank.accountno}}</span
					>
					</div>
					<div class="-copy-wrapper">
					<a
						href="javascript:void(0);"
						class="btn -btn js-copy-to-clipboard"
						v-clipboard:copy="bank.kbank.accountno.toString().replace(/-/g,'')"
														v-clipboard:success="clipboardSuccessHandler"
						>คัดลอก</a
					>
					</div>
				</div>
				</div>
	</div>
	<div class="mt-3 -spacer" v-if="bank && bank.scb && bank.bank && bank.scb.accountno && user.bank !== 'truewallet' && shouldUseStandardDepositBanks()">
		<div class="x-deposit-bank-info-container -v2">
		<div class="media m-auto">
			<img
			src="../assets/images/bank/scb.jpg"
			class="-img rounded-circle"
			width="50"
			height="50"
			alt="bank-bay"
			/>
			<div class="-content-wrapper">
			<span class="-name">ธนาคารไทยพาณิชย์</span>
			<span class="-own-name"
				>{{bank.scb.firstname}} {{bank.scb.lastname}}</span
			>
			<span id="depositBankNumber" class="-number"
				>{{bank.scb.accountno}}</span
			>
			</div>
			<div class="-copy-wrapper">
			<a
				href="javascript:void(0);"
				class="btn -btn js-copy-to-clipboard"
				v-clipboard:copy="bank.scb.accountno.replace(/-/g,'')"
												v-clipboard:success="clipboardSuccessHandler"
				>คัดลอก</a
			>
			</div>
		</div>
		</div>
	</div>

		<div class="mt-3 -spacer" v-if="canShowDepositBankAccounts() && bank && bank.truewallet && user && user.bank === 'truewallet'">
    <div class="x-deposit-bank-info-container -v2">
      <div class="media m-auto">
		<img
		src="../assets/images/bank/tmw.png"
		class="-img rounded-circle"
		width="50"
		height="50"
		alt="bank-bay"
		/>
		<div class="-content-wrapper">
		<span class="-name">ทรูมันนี่ วอลเล็ท</span>
		<span class="-own-name"
			>{{bank.truewallet.firstname}}  {{bank.truewallet.lastname}}</span
		>
		<span id="depositBankNumber2" class="-number"
			>{{bank.truewallet.mobile}}</span
		>
		</div>
		<div class="-copy-wrapper">
		<a
			href="javascript:void(0);"
			v-clipboard:copy="bank.truewallet.mobile.replace(/-/g,'')"
			v-clipboard:success="clipboardSuccessHandler"
			class="btn -btn js-copy-to-clipboard"
			>คัดลอก</a
		>
		</div>
      </div>
    </div>
  </div>
  <template v-if="shouldUseSlipReadingBanks()">
	<div class="mt-3 -spacer" v-for="(cb, idx) in customBanksList" :key="'custom-bank-'+idx">
		<div class="x-deposit-bank-info-container -v2">
			<div class="media m-auto">
				<img :src="getBankImage(cb.bankCode)" class="-img rounded-circle" width="50" height="50" alt="bank" />
				<div class="-content-wrapper">
					<span class="-name">{{getBankDisplayName(cb.bankCode)}}</span>
					<span class="-own-name">{{cb.firstname}} {{cb.lastname}}</span>
					<span class="-number">{{cb.accountno}}</span>
				</div>
				<div class="-copy-wrapper">
					<a href="javascript:void(0);" class="btn -btn js-copy-to-clipboard" v-clipboard:copy="(cb.accountno || '').toString().replace(/-/g,'')" v-clipboard:success="clipboardSuccessHandler">คัดลอก</a>
				</div>
			</div>
		</div>
	</div>
	<div class="-spacer" style="margin-top:8px;">
		<div style="background:linear-gradient(135deg,#ff6b35,#f48d1f);color:#fff;border-radius:8px;padding:10px 14px;text-align:center;font-family:'Kanit',sans-serif;">
			<span style="font-size:14px;font-weight:500;">โอนเสร็จแล้ว กรุณาอัพโหลดสลิปด้านล่างทุกครั้ง</span>
		</div>
	</div>
  </template>
							<div class="-spacer">
								<div class="x-danger-zone -v2 ">
								<span
									>กรุณาใช้เลขบัญชีที่สมัครโอนเข้ามาเท่านั้น</span
								>
								</div>
							</div>
						  	<div class="-spacer">
								<hr class="-liner">
							</div>
							

							<div class="x-deposit-promotion-outer-container js-scroll-ltr -fade -on-left -on-right" v-if="promotions && promotions.name">
								<div><p class="-title" style="font-family: 'Kanit', sans-serif; font-size: 12px; padding-bottom:10px;color:#fff">หากต้องการรับโปร โปรดกดรับโปรทุกครั้งก่อนโอนเงินนะคะ</p></div>
								<div class="x-deposit-promotion -v2 -slide pt-0" data-scroll-booster-container=".x-deposit-promotion-outer-container" data-scroll-booster-content=".x-deposit-promotion" style="transform: translate(0px, 0px);">
									<div :class="{'-promotion-box-wrapper':true,'-active':this.gotpro}" @click="receivePromotion()">
										<button type="button" :class="{'btn -promotion-box-apply-btn js-promotion-apply':true,'-active':this.gotpro}">
											<img src="../assets/images/ic-gift.png" class="-img" :alt="promotions.name" width="26" height="26">
											<span class="-title" style="font-size: 12px;">{{promotions.name}}</span>
										</button>
										<div class="mid">
										 <label class="rocker rocker-small" style="box-sizing: inherit;margin:0;padding:0;">
											<input type="checkbox" v-model="this.gotpro" @click="receivePromotion()">
											<span class="switch-left">รับ</span>
											<span class="switch-right">ไม่รับ</span>
										</label>
										</div>
										<!-- <a href="javascript:void(0)" :class="{'-promotion-box-cancel-btn js-cancel-promotion':true,'-show':this.gotpro}">
											<i class="fas fa-times"></i>
										</a> -->
									</div>

									<div class="-promotion-box-wrapper -active" style="font-family: Kanit, sans-serif;min-width: 65%;background: transparent;align-items: flex-start;justify-content: flex-start;" v-if="promotions.detail">
										<span style="font-size:16px">รายละเอียด</span>
										<span style="font-size:13px;text-align: left;" v-html="nl2br(promotions.detail)"></span>
									</div>

									<!-- <div class="-promotion-box-wrapper -active">
										<button type="button" class="btn -promotion-box-apply-btn js-promotion-apply -active" data-url="/promotion/27/apply" data-type="deposit" data-display-slide-mode="true">
											<img src="../assets/images/ic-gift.png" class="-img" alt="รับเพิ่ม 2% ทุกบิลฝาก" width="26" height="26">
											<span class="-title" style="font-size: 12px;">รับเพิ่ม 2% ทุกบิลฝาก</span>
										</button>
										<a href="javascript:void(0)" class="-promotion-box-cancel-btn js-cancel-promotion -show" data-url="/promotion-active/cancel" data-display-slide-mode="true">
											<i class="fas fa-times"></i>
										</a>
									</div> -->
    							</div>
 							</div>
							<div><p class="-description" style="font-family: 'Kanit', sans-serif;">ไม่รับโบนัส ถอนได้ทันที เพียงมียอดเล่นเท่าที่ฝาก</p></div>
							<div class="-spacer" style="cursor:pointer" @click="openBrowseFile()">
								<div v-if="shouldUseSlipReadingBanks()" class="x-danger-zone -v2" style="background:#28a745;color:#fff;border:2px solid #1e7e34;animation:pulse-green 1.5s infinite;">
								<span style="font-size:16px;font-weight:bold;">อัพโหลดสลิปที่นี่</span>
								</div>
								<div v-else class="x-danger-zone -v2" style="background:#f48d1f;color:#fff;">
								<span style="font-size:15px;">{{ giveaget ? 'หากยอดยังไม่เข้า อัปโหลดสลิปที่นี่' : 'หากเงินไม่เข้าภายใน 5 นาที อัพโหลดสลิปที่นี่!!' }}</span>
								</div>
							</div>

</div>
<div class="-top" v-else-if="corepayBankTransfer">
	<div class="alert alert-info" style="margin-bottom: 15px; padding: 10px; border-radius: 5px; text-align: center; font-weight: bold;">
		กรุณาโอนตามยอด {{ numberWithCommas(Number(corepayBankTransfer.amount || deposit_value || 0)) }} บาท
	</div>
	<div class="x-deposit-bank-info-container -v2">
		<div class="media m-auto">
			<img
				src="https://play-lh.googleusercontent.com/UIdkgBTFEFYTbE-_hUnekG5Aq16au9J7C6RI5gnoAeEZV2zMC3XgOnjL-0aYdmyWk6k=w240-h480-rw"
				class="-img rounded-circle"
				width="50"
				height="50"
				alt="corepay"
			/>
			<div class="-content-wrapper">
				<span class="-name">{{ corepayBankTransfer.bank_name || 'Corepay' }}</span>
				<span class="-own-name">{{ corepayBankTransfer.account_name }}</span>
				<span class="-number">{{ corepayBankTransfer.account_number }}</span>
			</div>
			<div class="-copy-wrapper">
				<a
					href="javascript:void(0);"
					class="btn -btn js-copy-to-clipboard"
					v-clipboard:copy="corepayBankTransfer.account_number"
					v-clipboard:success="clipboardSuccessHandler"
				>คัดลอก</a>
			</div>
		</div>
	</div>
	<div class="alert alert-warning mt-3" role="alert" style="font-size: 15px; text-align: center; font-weight: bold;">
		กรุณาคัดลอกเลขบัญชีนี้เท่านั้น และโอนยอดให้ตรงตามรายการ
		<span v-if="corepayBankTransfer.expiration_date"><br>หมดอายุ: {{ corepayBankTransfer.expiration_date }}</span>
	</div>
</div>
<div class="-top" v-else-if="corepayimage">
		<template v-if="isHiddenDepositBankAccountResponse()">
			<div class="x-danger-zone -v2" style="background:#f48d1f;color:#fff;">
				<span style="font-size:15px;">กรุณาฝากผ่านช่องทางพร้อมเพย์ หรือติดต่อแอดมิน</span>
			</div>
		</template>
		<template v-else-if="paymentmx && corepayimage">
		<!-- BANK_TRANSFER: แสดงข้อมูลธนาคารแทน QR Code -->
		<div class="bank-display-container">
			<div class="bank-card">
				<div class="bank-image-wrapper">
					<img :src="getBankImage(paymentmxBank.bank_code)" class="bank-image" alt="Bank Logo"/>
				</div>
				<div class="account-info">
					<!-- จำนวนเงินที่ต้องโอน -->
					<div class="amount-section">
						<div class="amount-label">
							<i class="fas fa-money-bill-wave"></i>
							<span>จำนวนเงินที่ต้องโอน</span>
						</div>
						<div class="amount-value"
							v-clipboard:copy="paymentmxBank.amount.toString()"
							v-clipboard:success="clipboardSuccessHandler"
							title="คลิกเพื่อคัดลอก">
							{{Number(paymentmxBank.amount).toLocaleString('th-TH', {minimumFractionDigits: 2, maximumFractionDigits: 2})}} บาท
						</div>
						<button
							class="copy-button copy-amount-button"
							v-clipboard:copy="paymentmxBank.amount.toString()"
							v-clipboard:success="clipboardSuccessHandler">
							<i class="fas fa-copy"></i> คัดลอกจำนวนเงิน
						</button>
						<div class="amount-warning">
							<i class="fas fa-exclamation-triangle"></i>
							<span>**สำคัญ** กรุณาโอนตามจำนวนนี้เท่านั้น เพื่อให้ระบบตรวจสอบอัตโนมัติได้รวดเร็ว</span>
						</div>
					</div>

					<!-- ชื่อบัญชี -->
					<div class="account-name-section">
						<div class="account-label">
							<i class="fas fa-user"></i>
							<span>ชื่อบัญชี</span>
						</div>
						<div class="account-name">{{paymentmxBank.account_name}}</div>
					</div>

					<!-- หมายเลขบัญชี -->
					<div class="account-label">
						<i class="fas fa-university"></i>
						<span>หมายเลขบัญชี</span>
					</div>
					<div class="account-number"
						v-clipboard:copy="paymentmxBank.bank_no.toString().replace(/-/g,'')"
						v-clipboard:success="clipboardSuccessHandler"
						title="คลิกเพื่อคัดลอก">
						{{paymentmxBank.bank_no}}
					</div>
					<button
						class="copy-button"
						v-clipboard:copy="paymentmxBank.bank_no.toString().replace(/-/g,'')"
						v-clipboard:success="clipboardSuccessHandler">
						<i class="fas fa-copy"></i> คัดลอกเลขบัญชี
					</button>
				</div>
			</div>
		</div>
	</template>
	<template v-else-if="bungpay && bungpayMode === 'TRANSFER' && corepayimage === 'bank'">
		<div class="bank-display-container">
			<div class="bank-card">
				<div class="bank-image-wrapper">
					<img v-if="bungpayBank.bankName" :src="getBankImageFromCode(bungpayBank.bankName)" class="bank-image" alt="Bank Logo"/>
				</div>
				<div class="account-info">
					<div class="amount-section">
						<div class="amount-label">
							<i class="fas fa-money-bill-wave"></i>
							<span>จำนวนเงินที่ต้องโอน</span>
						</div>
						<div class="amount-value"
							v-clipboard:copy="String(bungpayBank.depositAmount)"
							v-clipboard:success="clipboardSuccessHandler"
							title="คลิกเพื่อคัดลอก">
							{{ Number(bungpayBank.depositAmount).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} บาท
						</div>
						<button class="copy-button copy-amount-button"
							v-clipboard:copy="String(bungpayBank.depositAmount)"
							v-clipboard:success="clipboardSuccessHandler">
							<i class="fas fa-copy"></i> คัดลอกจำนวนเงิน
						</button>
						<div class="amount-warning">
							<i class="fas fa-exclamation-triangle"></i>
							<span>สำคัญ กรุณาโอนตามจำนวนนี้เท่านั้น เพื่อให้ระบบตรวจสอบอัตโนมัติได้รวดเร็ว</span>
						</div>
					</div>
					<div class="account-name-section">
						<div class="account-label">
							<i class="fas fa-user"></i>
							<span>ชื่อบัญชี</span>
						</div>
						<div class="account-name">{{ bungpayBank.bankAccountName }}</div>
					</div>
					<div class="account-label">
						<i class="fas fa-university"></i>
						<span>หมายเลขบัญชี</span>
					</div>
					<div class="account-number"
						v-clipboard:copy="(bungpayBank.bankAccountNumber || '').replace(/-/g,'')"
						v-clipboard:success="clipboardSuccessHandler"
						title="คลิกเพื่อคัดลอก">
						{{ bungpayBank.bankAccountNumber }}
					</div>
					<button class="copy-button"
						v-clipboard:copy="(bungpayBank.bankAccountNumber || '').replace(/-/g,'')"
						v-clipboard:success="clipboardSuccessHandler">
						<i class="fas fa-copy"></i> คัดลอกเลขบัญชี
					</button>
				</div>
			</div>
		</div>
	</template>
	<template v-else-if="bungpay">
		<div class="alert alert-warning" style="margin-bottom: 15px; padding: 10px; border-radius: 5px; background-color: #fff3cd; border: 1px solid #ffeaa7; color: #856404;">
			<i class="fas fa-exclamation-triangle" style="margin-right: 8px;"></i>
			<strong>คำเตือน:</strong> QR CODE นี้ชำระได้เพียงครั้งเดียวเท่านั้น ห้ามทำรายการซ้ำ หากทำซ้ำอาจจะทำให้ยอดเงินของท่านเข้าล่าช้าได้
		</div>
		<img :src='"data:image/jpeg;base64,"+corepayimage' style='width: 100%;'/>
	</template>
	<template v-else-if="fynpay && fynpaydata.bank">
		<div class="bank-display-container">
			<div class="bank-card">
			<div class="bank-image-wrapper">
				<img :src="require(`@/assets/images/bank/${fynpaydata.bank}.jpg`)" class="bank-image" alt="Bank Logo"/>
			</div>
				<div class="account-info">
					<!-- จำนวนเงินที่ต้องโอน -->
					<div v-if="fynpaydata.requestedAmount" class="amount-section">
						<div class="amount-label">
							<i class="fas fa-money-bill-wave"></i>
							<span>จำนวนเงินที่ต้องโอน</span>
						</div>
						<div class="amount-value"
							v-clipboard:copy="fynpaydata.requestedAmount.toString()"
							v-clipboard:success="clipboardSuccessHandler"
							title="คลิกเพื่อคัดลอก">
							{{Number(fynpaydata.requestedAmount).toLocaleString('th-TH', {minimumFractionDigits: 2, maximumFractionDigits: 2})}} บาท
						</div>
						<button 
							class="copy-button copy-amount-button"
							v-clipboard:copy="fynpaydata.requestedAmount.toString()"
							v-clipboard:success="clipboardSuccessHandler">
							<i class="fas fa-copy"></i> คัดลอกจำนวนเงิน
						</button>
						<div class="amount-warning">
							<i class="fas fa-exclamation-triangle"></i>
							<span>**สำคัญ** กรุณาโอนตามจำนวนนี้เท่านั้น เพื่อให้ระบบตรวจสอบอัตโนมัติได้รวดเร็ว</span>
						</div>
					</div>

					<!-- หมายเลขบัญชี -->
					<div class="account-label">
						<i class="fas fa-university"></i>
						<span>หมายเลขบัญชี</span>
					</div>
					<div class="account-number"
						v-clipboard:copy="fynpaydata.account_no.toString().replace(/-/g,'')"
						v-clipboard:success="clipboardSuccessHandler"
						title="คลิกเพื่อคัดลอก">
						{{fynpaydata.account_no}}
					</div>
					<button 
						class="copy-button"
						v-clipboard:copy="fynpaydata.account_no.toString().replace(/-/g,'')"
						v-clipboard:success="clipboardSuccessHandler">
						<i class="fas fa-copy"></i> คัดลอกเลขบัญชี
					</button>
				</div>
			</div>
		</div>
	</template>
	<template v-else-if="giveaget && corepayimage">
		<div class="alert alert-warning" style="margin-bottom: 15px; padding: 10px; border-radius: 5px; background-color: #fff3cd; border: 1px solid #ffeaa7; color: #856404;">
			<i class="fas fa-exclamation-triangle" style="margin-right: 8px;"></i>
			<strong>คำเตือน:</strong> QR CODE นี้ชำระได้เพียงครั้งเดียวเท่านั้น ห้ามทำรายการซ้ำ
		</div>
		<div class="alert alert-info" style="margin-bottom: 15px; padding: 10px; border-radius: 5px; text-align: center; font-weight: bold;">
			กรุณาโอนตามยอด
			{{ numberWithCommas(giveagetTransferAmount || getGiveagetTransferAmount(deposit_value)) }}
			บาท
		</div>
		<img :src="corepayimage" style="width: 100%;"/>
		<div
			class="x-danger-zone -v2 mt-3"
			style="background:#f48d1f;color:#fff;cursor:pointer;"
			@click="openBrowseFile()"
		>
			<span style="font-size:15px;">หากยอดยังไม่เข้า อัปโหลดสลิปที่นี่</span>
		</div>
	</template>
	<template v-else-if="!paymentmx">
	<iframe :src="corepayimage" width="100%" style="height:90vh;"></iframe>
	</template>
		<div class="alert alert-warning mt-3" role="alert" style="text-align: center; font-weight: bold;" v-if="!paymentmx && !isHiddenDepositBankAccountResponse()">
			QR CODE นี้ใช้ได้ครั้งเดียวเท่านั้น! ห้ามสแกนซ้ำเด็ดขาด!
		</div>
		<div class="alert alert-info mt-3" role="alert" style="text-align: center; font-weight: bold;" v-else-if="!isHiddenDepositBankAccountResponse()">
			กรุณาโอนเงินตามจำนวนและเลขบัญชีที่แสดง ระบบจะตรวจสอบอัตโนมัติ
		</div>
</div>
<div class="-top" v-else-if="corepaymessage">
	{{corepaymessage}}
</div>
<div class="-top" v-else-if="paybridgeMatch">
	<div class="paybridge-panel">
		<div class="paybridge-panel-header">
			<span class="paybridge-badge"><span class="paybridge-mark"></span>PayBridge</span>
			<h3>{{ paybridgeAcknowledged ? 'บัญชีโอนเงินของรายการนี้' : 'อ่านก่อนรับบัญชีโอนเงิน' }}</h3>
			<p>{{ paybridgeAcknowledged ? 'โอนยอดตามนี้ แล้วแนบสลิปเพื่อให้ระบบตรวจอัตโนมัติ' : 'ทำตาม 4 ข้อนี้เพื่อให้เครดิตเข้าถูกต้อง' }}</p>
			<div class="paybridge-route">
				<span>{{ paybridgeAcknowledged ? 'Matched' : 'Lock' }}</span>
				<span>{{ paybridgeAcknowledged ? 'Held' : 'Match' }}</span>
				<span>{{ paybridgeAcknowledged ? 'Ready' : 'Verify' }}</span>
			</div>
		</div>
	<div class="paybridge-customer-warning">
		<div class="paybridge-customer-warning-head">
			<span>สำคัญมาก ก่อนโอนเงิน</span>
			<strong v-if="paybridgeTaskRemainingText">เหลือเวลา {{ paybridgeTaskRemainingText }}</strong>
		</div>
		<div class="paybridge-customer-warning-grid">
			<div class="paybridge-customer-warning-item">
				<strong class="paybridge-warning-no">1</strong>
				<div><b>ห้ามฝากซ้ำบัญชีเดิม</b><small>บัญชีปลายทางนี้ใช้ได้เฉพาะรายการนี้ เปิดรายการฝากใหม่ทุกครั้งก่อนฝากครั้งถัดไป</small></div>
			</div>
			<div class="paybridge-customer-warning-item">
				<strong class="paybridge-warning-no">2</strong>
				<div><b>ต้องโอนภายในเวลาที่กำหนด</b><small>ถ้าหมดเวลาแล้ว ห้ามโอนไปบัญชีนี้ ให้กลับไปสร้างรายการฝากใหม่</small></div>
			</div>
			<div class="paybridge-customer-warning-item">
				<strong class="paybridge-warning-no">3</strong>
				<div><b>ต้องโอนยอดตรงเป๊ะ</b><small>โอนตามยอดที่แสดงเท่านั้น ห้ามขาด ห้ามเกิน ห้ามปัดเศษ</small></div>
			</div>
			<div class="paybridge-customer-warning-item">
				<strong class="paybridge-warning-no">4</strong>
				<div><b>ผิดเงื่อนไขไม่รับผิดชอบ</b><small>โอนผิดยอด โอนช้า หรือโอนซ้ำบัญชีเดิม ระบบอาจไม่ตรวจให้อัตโนมัติ</small></div>
			</div>
		</div>
		<div class="paybridge-customer-warning-footer">หลังโอนแล้วให้อัปโหลดสลิปทันทีเพื่อยืนยันรายการ</div>
	</div>
		<div class="paybridge-agreement-card" v-if="!paybridgeAcknowledged">
			<div class="paybridge-agreement-list">
				<div class="paybridge-agreement-item -one">
					<strong>1</strong>
					<span><b>บัญชีใช้ได้ครั้งเดียว</b><small>ห้ามบันทึกหรือโอนซ้ำ</small></span>
				</div>
				<div class="paybridge-agreement-item -two">
					<strong>2</strong>
					<span><b>โอนยอดให้ตรง</b><small>ห้ามโอนขาดหรือเกิน</small></span>
				</div>
				<div class="paybridge-agreement-item -three">
					<strong>3</strong>
					<span><b>ต้องอัปโหลดสลิป</b><small>ไม่แนบสลิป เครดิตไม่เข้า</small></span>
				</div>
			</div>
			<div class="paybridge-agreement-final">
				หากโอนผิดยอด โอนเกินเวลา ใช้บัญชีซ้ำ หรือไม่แนบสลิป ระบบไม่สามารถรับผิดชอบได้
			</div>
			<button type="button" class="paybridge-ack-button" @click="acknowledgePayBridgeTerms()">
				<i class="fas fa-check-circle"></i>
				รับทราบและแสดงบัญชีโอนเงิน
			</button>
			<button type="button" class="paybridge-cancel-button" @click="cancelPayBridgeTask()">
				<i class="fas fa-times-circle"></i>
				ยกเลิกรายการนี้
			</button>
		</div>
		<template v-else>
			<div class="paybridge-amount-card">
				<div>
					<span>ยอดที่ต้องโอน</span>
					<strong>
						{{ numberWithCommas(Number(deposit_value || 0)) }} บาท
						<button
							type="button"
							class="paybridge-icon-copy"
							v-clipboard:copy="String(Number(deposit_value || 0))"
							v-clipboard:success="clipboardSuccessHandler"
							aria-label="คัดลอกยอดโอน"
						>
							<i class="fas fa-copy"></i>
						</button>
					</strong>
				</div>
				<div class="paybridge-timer">{{ paybridgeTaskRemainingText || '5:00' }}</div>
			</div>
			<div class="paybridge-account-card">
				<div class="paybridge-bank-mark">
					<img :src="getPayBridgeBankImage(paybridgeMatch.recipientAccount.bankCode)" alt="paybridge"/>
				</div>
				<div class="paybridge-account-detail">
					<span class="paybridge-bank-name">{{ paybridgeMatch.recipientAccount.bankName || paybridgeMatch.recipientAccount.bankCode || 'ธนาคาร' }}</span>
					<strong class="paybridge-account-name">{{ paybridgeMatch.recipientAccount.accountName }}</strong>
					<div class="paybridge-account-number">
						{{ paybridgeMatch.recipientAccount.accountNo }}
						<button
							type="button"
							class="paybridge-icon-copy"
							v-clipboard:copy="paybridgeMatch.recipientAccount.accountNo.toString().replace(/-/g,'')"
							v-clipboard:success="clipboardSuccessHandler"
							aria-label="คัดลอกเลขบัญชี"
						>
							<i class="fas fa-copy"></i>
						</button>
					</div>
				</div>
			</div>
			<div class="paybridge-critical-warning">
				<div class="paybridge-warning-icon">
					<i class="fas fa-exclamation-triangle"></i>
				</div>
				<div class="paybridge-warning-copy">
					<span>บัญชีนี้ใช้ได้เฉพาะรายการนี้และต้องโอนภายในเวลาที่กำหนดเท่านั้น หากโอนซ้ำบัญชีเดิม โอนช้า หรือโอนผิดยอด ทางเว็บจะไม่รับผิดชอบใดๆ</span>
				</div>
			</div>
			<div class="paybridge-slip-actions">
				<button type="button" class="paybridge-upload-button" @click="openBrowsePayBridgeFile()">
					<i class="fas fa-receipt"></i>
					อัปโหลดสลิป
				</button>
				<input class="paybridge-file-input" type="file" id="my_file_paybridge" accept="image/*" @change="uploadPayBridgeSlip">
			</div>
			<button type="button" class="paybridge-cancel-button -after-account" @click="cancelPayBridgeTask()">
				<i class="fas fa-times-circle"></i>
				ยกเลิกรายการนี้
			</button>
		</template>
	</div>
</div>
<div class="-top" style="padding-bottom: 30px;" v-else-if="corepaypage">
  <div class="x-deposit-bank-info-container -v2" style="background-color: transparent;">
		<div class="media m-auto">
        <div
          data-animatable="fadeInModal"
          class="-animatable-container animated fadeInModal" style="width:80%"
        >
          <div class="text-center d-flex flex-column" style="bottom: 30px;">
          <div
            class="-x-input-icon x-input-operator mb-3 flex-column"
          >
        <button
        type="button"
        class="-icon-left -btn-icon js-adjust-amount-by-operator"
        @click="setWithdraw2('minus')"
        >
        <i class="fas fa-minus-circle"></i>
        </button>
        <input
        type="text"
        v-model="deposit_value"
        :class="{'x-form-control':true,'text-center':true, 'js-withdraw-input-amount':true ,'-no':true,'form-control':true,'is-invalid':(error)?true:false}"
        placeholder="จำนวนเงินที่ต้องการฝาก"
        @keypress="isNumber($event)"

        />
                    <div class="invalid-feedback " v-if="error">
                      <ul class="list-unstyled mb-0"><li>{{error}}</li></ul>
                    </div>
					<div
						v-if="giveaget && deposit_value && Number(deposit_value) >= 100"
						class="alert alert-info mt-2"
						role="alert"
						style="text-align: center; font-weight: bold;"
					>
						ยอดที่ต้องโอนผ่าน Giveaget จะเป็น
						{{ numberWithCommas(getGiveagetTransferAmount(deposit_value)) }}
						บาท
					</div>
        <button
        type="button"
        class="-icon-right -btn-icon js-adjust-amount-by-operator"
        @click="setWithdraw2('plus')"
        >
        <i class="fas fa-plus-circle"></i>
        </button>
          </div>
          <div
        class="x-select-amount js-quick-amount -v2"
        data-target-input="#withdraw_amount"
          >
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(100)"
        >
          <span class="-no">100</span>
        </button>
        </div>
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(300)"
        >
          <span class="-no">300</span>
        </button>
        </div>
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(500)"
        >
          <span class="-no">500</span>
        </button>
        </div>
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(1000)"
        >
          <span class="-no">1000</span>
        </button>
        </div>
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(2000)"
        >
          <span class="-no">2000</span>
        </button>
        </div>
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(5000)"
        >
          <span class="-no">5000</span>
        </button>
        </div>
          </div>
          </div>
        </div>
		</div>
	</div>
	<div>
                  <p class="glow" style="font-size:14px;">
                    พิมพ์ใส่ยอดที่ต้องการฝากหรือกดเลือกยอดตามที่แสดงได้เลยค่ะ
                  </p>
                  </div>
</div>

<div class="-bottom ">
	  <div class="my-3 -spacer" v-if="!corepaypage || corepayimage || corepayBankTransfer || paybridgeMatch">
    <button
      type="button"
      class="btn -submit btn-primary text-center m-auto js-user-confirm-deposit"
      data-dismiss="modal"
      aria-label="Close"
    >
      ปิดหน้าต่าง
    </button>
  </div>
  <div class="my-3 -spacer" v-else>
    <button
      type="button"
      class="btn -submit btn-primary text-center m-auto js-user-confirm-deposit"
	  @click="genQrCodeCorePay()"
    >
      <span v-if="!paybridgeChecking">ยืนยันการฝาก</span>
      <span v-else>
        <i class="fas fa-spinner fa-spin"></i>
        กำลังค้นหา PayBridge...
      </span>
    </button>
  </div>
</div>
      </div>
    </div>
  </div>
</div>
      </div>
    </div>
  </div>
</div>
      	</div>

<!--Anoucement-->
<div id="open-modal" class="modal-window">
  <div>
    <a href="#" id="an-close" title="Close" style="display:none" class="modal-close">Close</a>
    <h1>{{announcement_user.title}}</h1>
    <div v-html="nl2br(announcement_user.detail)" style="font-size:15px;font-family: 'Kanit', sans-serif;"></div>
	<font size="2" style="font-family: 'Kanit', sans-serif;">{{showDateTime(announcement_user.createdate)}}</font>
    <div style=" display: flex; justify-content: space-between;padding-top:20px;">
		<button style="border: 2px solid #1e1eff;background-color: #000;color:#fff; border-radius: 50px;font-family: 'Kanit', sans-serif;" @click="closeAnnouncement(1)">รับทราบแล้ว</button>
		<button style="border: 2px solid #1e1eff;background-color: #000;color:#fff; border-radius: 50px;font-family: 'Kanit', sans-serif;" @click="closeAnnouncement(2)">ข้ามไปก่อน</button>
	</div>
  </div>
</div>
<!-- Promotion -->
		  <div data-loading-container=".modal-body" data-container=".promotion-detail-modal-27" data-ajax-modal-always-reload="true" tabindex="-1" class="modal x-modal -promotion-detail-modal promotion-detail-modal-27 show" aria-modal="true" :style="`display: ${(promotion && promotion.name)?`block`:'none'}; padding-right: 8px;`"><div class="modal-dialog -modal-size  " role="document" style="padding-top: 152.8px;">
    <div class="modal-content -modal-content" :style="{ 'background-image': `url(${require('../assets/images/Shiba-BG.jpg')})`}">
                    <button type="button" class="close f-1 " data-dismiss="modal" aria-label="Close" @click="closePromotion()">
                <i class="fas fa-times"></i>
            </button>
                                <div class="modal-body -modal-body" style="top: 0px;">
                            
        <div class="container">
            <div class="row">
                <div class="col-12 mt-4">
                    <div class="x-page-title-component ">
    <div class="-inner-wrapper">
        <h1 class="-title">โปรโมชั่น</h1>
            </div>
</div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-column">
                            <div class="-real-content">
                    
    <div class="x-card card -card-promotion-detail ">
                                            
            <div class="card-body">
                <div class="-img-container">
                    <img :src="promotion.image" :alt="promotion.name" class="-img-promotion img-fluid">
                </div>


                <div class="x-promotion-content"><h2>{{promotion.name}}</h2>

<p><br>
<div v-html="nl2br(promotion.detail)" style="font-size:15px;font-family: 'Kanit', sans-serif;">
</div>
<br>
<!-- <a href="/term-and-condition">เงื่อนไขและกติกาพื้นฐานจะถูกนำมาใช้กับโปรโมชั่นนี้</a> -->
</p></div>
            </div>

                            <div class="card-footer">
                    <!-- <button class="btn -btn -get-promotion-btn js-promotion-apply " data-toggle="modal" data-target="#depositModal" data-promotion-target="promotion-detail-modal-27" data-type="deposit" data-dismiss="modal" data-url="/promotion/27/apply">
                        <span>รับโปรโมชั่น</span>
                    </button> -->
                </div>
                        </div>
                </div>
            
                                                        
                                    <div class="mx-3 mb-3">
                        <div class="x-admin-contact -no-fixed">
                            <span class="x-text-with-link-component" style="font-size:15px;font-family: 'Kanit', sans-serif;">
     <label class="-text-message ">ติดปัญหา&nbsp;</label>&nbsp;
     <a href="https://lin.ee/rrSbqfG" class="-link-message " target="_blank" rel="noopener">
        <u>ติดต่อฝ่ายบริการลูกค้า</u>
    </a>
</span>
                        </div>
                    </div>
                                    </div>
            </div>
    </div>
</div></div>
    <a class="btn" href="#open-modal" id="a-modal" style="display: none;">👋 Basic CSS-Only Modal</a>
	</header>
</template>
<script>
import queryString from 'querystring'
import firebase from 'firebase/app'
import 'firebase/database'
import router from './../router'
import moment from 'moment'
const audio = new Audio(require('../assets/money.mp3'))
const audio2 = new Audio(require('../assets/moneyout.mp3'))
const axios = require('axios').default
const qs = require('qs')
const PAYBRIDGE_FRONTEND_ENABLED = true
const PAYBRIDGE_ALLOWED_USER_CODES = [] // ใส่ code ลูกค้าที่ให้ทดสอบ PayBridge เช่น ['DP001'] — ปล่อยว่าง = เปิดทุก user
export default {
  name: "Header",
  mounted () {
   	const user = localStorage.getItem('userData');
	if(user){
		const _user = JSON.parse(user);
		if(!_user.lastlogin || _user.lastlogin !== moment().tz('Asia/Bangkok').format('YYYY-MM-DD')){
			_user.lastlogin = moment().tz('Asia/Bangkok').format('YYYY-MM-DD')
			localStorage.setItem('userData', JSON.stringify(_user))
			this.addLogin(_user)
		}
		this.restorePayBridgeTask();
		this.paybridgeTaskTimer = setInterval(() => {
			this.paybridgeNow = Date.now();
			this.expirePayBridgeTaskIfNeeded();
		}, 1000);
		$('#depositModal').on('hidden.bs.modal',  (e)=> {
				this.corepaypage = false;
				this.corepayimage = '';
				this.corepayBankTransfer = null;
			this.fynpay = this.fynpaymain;
			this.aha = this.ahamain;
			this.corepay = this.corepaymain;
			if(!this.hasActivePayBridgeTask){
				this.paybridgeFallback = false;
				this.paybridgeMatch = null;
				this.paybridgeLocalDepositId = '';
				this.paybridgeMessage = '';
				this.paybridgeAcknowledged = false;
			}
			if(this.unsubscribe){
				this.unsubscribe()
			}
			this.fynpaydata = {
				bank:'',
				account_no:'',
				requestedAmount:'',
			}
        });
		$('#depositModal').on('shown.bs.modal',  (e)=> {
			this.restorePayBridgeTask();
			if(this.hasActivePayBridgeTask){
				this.corepaypage = true;
			}else if(PAYBRIDGE_FRONTEND_ENABLED && this.paybridge && !this.paybridgeFallback){
				this.corepaypage = true;
			}
        });
		this.getAnnouncementUser(_user.key);
	  }else{
		firebase.auth().signOut()
		localStorage.removeItem('userData')
		router.replace('/login')
	  }
  },
  beforeDestroy() {
	if(this.paybridgeTaskTimer){
		clearInterval(this.paybridgeTaskTimer);
		this.paybridgeTaskTimer = null;
	}
	// Cleanup: unsubscribe listener และยกเลิก timeout
	if(this.unsubscribe) {
		this.unsubscribe();
		this.unsubscribe = null;
	}
	if(this.fynpayTimeout) {
		clearTimeout(this.fynpayTimeout);
		this.fynpayTimeout = null;
	}
  },
  async created(){
	  //$("#depositChoosePromotionModal").modal('show')
	const user = localStorage.getItem('userData');
	if(user){
		const _user = JSON.parse(user);
		await this.$store.dispatch('user/setUser',_user).catch(err => { console.error(err) });
		this.getBankDeposit();
	}else{
		firebase.auth().signOut()
		localStorage.removeItem('userData')
		router.replace('/login')
	}
	const { code } = queryString.parse(window.location.search.replace('?', ''))
	if (!code) return
	const result = await this.getToken(code)
	if (result && result.access_token) {
		const { data } = await this.getProfile(result.access_token)
		this.checkLineLogin(data)
	}
  },
  data() {
    return {
		withdrawSubmitting: false,
		fynpaydata:{
			bank:'',
			account_no:'',
			requestedAmount:'',
		},
		paymentmxBank:{
			bank_code:'',
			bank_no:'',
			bank_name:'',
			account_name:'',
			amount:0
		},
		bungpayBank:{
			bankAccountNumber:'',
			bankAccountName:'',
			bankName:'',
			bankCode:'',
			depositAmount:0
		},
		fynpayTimeout:null,
			corepaymessage:'',
			unsubscribe:null,
			corepayimage:'',
			corepayPaymentMode:'qrcode',
			corepayBankTransfer:null,
		giveagetTransferAmount: 0,
		currentGiveagetDocId: '',
		currentGiveagetOrderId: '',
		deposit_value:'',
		corepaypage:false,
		paybridge:false,
		paybridgeChecking:false,
		paybridgeFallback:false,
		paybridgeMatch:null,
		paybridgeLocalDepositId:'',
		paybridgeMessage:'',
		paybridgeAcknowledged:false,
		paybridgeNow:Date.now(),
		paybridgeTaskTimer:null,
		paybridgeExpiredNotified:false,
		corepay: false,
		corepaymain: false,
		paymentmx: false,
		paymentmxmain: false,
		giveaget: false,
		giveagetmain: false,
		papaya: false,
		aha: false,
		ahamain: false,
		fynpay:false,
		fynpaymain: false,
		coolpay: false,
		nowpay: false,
		papayamain: false,
		coolpaymain: false,
		onepay: false,
		onepaymain: false,
		bungpay: false,
		bungpayMode: 'QR',
		bungpaymain: false,
		isProcessing: false,
		announcement_user:{
			close:false,
			createdate:'',
			detail:'',
			title:'',
		},
		password:'',
			password1:'',
			password2:'',
			fa_spin:false,
			accountOpen:false,
			withdraw: '',
			error: '',
			copyfield:'',
			canwithdraw:'ยืนยัน',
			clientId: '1656935750',
			callbackUri: 'https://deltaplus.com',
			clientSecret: '4b4c6d35256b0034244f1a0056ddb640',
			customBanksList:[],
			slipReading:false,
			bank:{
				giveagetSlipEnabled:false,
				giveagetSlipUseTimeWindow:false,
				giveagetSlipStartTime:'23:00',
				giveagetSlipEndTime:'02:00',
				scb:{
					firstname:'',
					lastname:'',
					accountno:'',
				},
				truewallet:{
					firstname:'',
					lastname:'',
					mobile:'',
				}
			},
    }
  },
  watch: {
    // whenever question changes, this function will run
    creditincrese(newQuestion, oldQuestion) {
		if(newQuestion){
			audio.volume = 0.5;
			audio.play();
			this.$store.commit("user/SET_CREDIT_INCREASE", false) 
		}
    },
	creditdecrese(newQuestion, oldQuestion) {
		if(newQuestion){
			audio2.volume = 0.5;
			audio2.play();
			this.$store.commit("user/SET_CREDIT_DECREASE", false) 
		}
    },
	
	alertwithdraw(newalert, oldwithdraw) {
		if(newalert){
			if(Number(this.lastbonus.turncredit) <= Number(this.user.credit)){
				if(Number(this.lastbonus.canwithdraw) > 0 && Number(this.user.credit) >= Number(this.lastbonus.canwithdraw)){
					$("#withdrawModal").modal('hide')
					this.$swal({ icon: 'question', title: 'แจ้งถอน', html: `คุณทำเทิร์นครบแล้ว! จะถอนได้ ${this.lastbonus.canwithdraw} บาท<br> กดปุ่มยืนยันการถอนได้เลยค่ะ`,showCancelButton: true,confirmButtonText: 'ยืนยัน'}).then((result) => {
						if(result.isConfirmed){
							this.withdraw = this.user.credit;
							this.withdrawConfirm();
						}
					});
				}else{
					$("#withdrawModal").modal('hide')
					this.$swal({ icon: 'question', title: 'แจ้งถอน', text: `คุณทำเทิร์นครบแล้ว! กดปุ่มยืนยันการถอนได้เลยค่ะ`,showCancelButton: true,confirmButtonText: 'ยืนยัน'}).then((result) => {
						if(result.isConfirmed){
							this.withdraw = this.user.credit;
							this.withdrawConfirm();
						}
					});
				}
			}else if(Number(this.user.credit)>5){
				$("#withdrawModal").modal('hide')
				this.$swal({ icon: 'error', title: 'แจ้งถอน', text: `คุณต้องทำยอด ${this.lastbonus.turncredit} ค่ะ`}).then((result) => {
				});
			}
			this.$store.commit("user/SET_ALERT_WITHDRAWALL", false) 
		}
	}
  },
  computed: {
	hasActivePayBridgeTask(){
		return !!this.paybridgeMatch && !this.isPayBridgeTaskExpired();
	},
	paybridgeTaskRemainingSeconds(){
		if(!this.paybridgeMatch || !this.paybridgeMatch.expiresAt) return 0;
		const expiresAtMs = Date.parse(this.paybridgeMatch.expiresAt);
		if(!expiresAtMs) return 0;
		return Math.max(0, Math.ceil((expiresAtMs - this.paybridgeNow) / 1000));
	},
	paybridgeTaskRemainingText(){
		if(!this.paybridgeTaskRemainingSeconds) return '';
		const minutes = Math.floor(this.paybridgeTaskRemainingSeconds / 60);
		const seconds = this.paybridgeTaskRemainingSeconds % 60;
		return minutes > 0 ? `${minutes}:${seconds.toString().padStart(2, '0')}` : `${seconds}s`;
	},
	user(){
		return this.$store.state.user.user;
    },
	creditincrese(){
		return this.$store.state.user.creditincrese;
	},
	creditdecrese(){
		return this.$store.state.user.creditdecrese;
	},
	lastbonus () {
      return this.$store.state.user.lastbonus;
    },
	alertwithdraw (){
		return this.$store.state.user.alertwithdraw;
	},
	promotions (){
		return this.$store.state.user.promotions;
	},
	gotpro (){
		return this.$store.state.user.gotpro;
	},
	promotion(){
		return this.$store.state.user.promotion;
	},
	loading () {
      return this.$store.state.user.loading
    }
  },
  methods: {
	normalizeCorepayPaymentMode(value) {
		return value === 'account' ? 'account' : 'qrcode';
	},
	normalizeCorepayBankTransfer(value) {
		if(!value) return null;
		return {
			account_number: value.account_number || value.accountNo || value.account_no || '',
			account_name: value.bank_card_name || value.account_name || value.accountName || '',
			bank_name: value.bank_name || value.bankName || '',
			amount: value.bank_discount_amount || value.amount || '',
			expiration_date: value.expiration_date || ''
		};
	},
	getBankImage(bankCode) {
		const bankMap = {
			'002': 'bankokbank',
			'004': 'kbank',
			'006': 'ktb',
			'011': 'ttb',
			'014': 'scb',
			'020': 'standard',
			'022': 'cimb',
			'024': 'uob',
			'025': 'krungsri',
			'030': 'gsb',
			'033': 'ghbank',
			'034': 'baac',
			'065': 'thanachart',
			'066': 'ธนาคารอิสลาม',
			'067': 'tisco',
			'069': 'kiatnakin',
			'070': 'icbc',
			'073': 'lh',
			bbl: 'bankokbank',
			bankokbank: 'bankokbank',
			kbank: 'kbank',
			scb: 'scb',
			ttb: 'ttb',
			ktb: 'ktb',
			krungsri: 'krungsri',
			gsb: 'gsb',
			baac: 'baac',
			cimb: 'cimb',
			uob: 'uob',
			kkp: 'kiatnakin',
			kiatnakin: 'kiatnakin',
			ghbank: 'ghbank',
			tisco: 'tisco',
			lh: 'lh',
			hbl: 'hbl',
			HBL: 'hbl',
			truewallet: 'tmw'
		};
		const bankName = bankMap[bankCode] || 'kbank';
		try {
			return require(`@/assets/images/bank/${bankName}.jpg`);
		} catch (e) {
			return require(`@/assets/images/bank/${bankName}.png`);
		}
	},
	getBankDisplayName(bankCode) {
		const map = {
			bankokbank: 'ธนาคารกรุงเทพ',
			bbl: 'ธนาคารกรุงเทพ',
			kbank: 'ธนาคารกสิกรไทย',
			scb: 'ธนาคารไทยพาณิชย์',
			ttb: 'ธนาคารทหารไทยธนชาต',
			ktb: 'ธนาคารกรุงไทย',
			krungsri: 'ธนาคารกรุงศรีอยุธยา',
			gsb: 'ธนาคารออมสิน',
			baac: 'ธ.ก.ส.',
			cimb: 'ธนาคาร CIMB',
			uob: 'ธนาคาร UOB',
			kkp: 'ธนาคารเกียรตินาคินภัทร',
			kiatnakin: 'ธนาคารเกียรตินาคินภัทร',
			ghbank: 'ธนาคารอาคารสงเคราะห์',
			tisco: 'ธนาคารทิสโก้',
			lh: 'ธนาคารแลนด์ แอนด์ เฮ้าส์',
			hbl: 'HBL (Habib Bank Limited)',
			HBL: 'HBL (Habib Bank Limited)',
			truewallet: 'ทรูมันนี่ วอลเล็ท'
		};
		return map[bankCode] || bankCode;
	},
	isLowDepositUser(){
		if(!this.user){
			return true;
		}
		const depositTotal = Number(`${this.user.deposittotal || 0}`.replace(/,/g, ''));
		return !Number.isFinite(depositTotal) || depositTotal < 50000;
	},
	canShowDepositBankAccounts(){
		return !this.isLowDepositUser();
	},
	shouldUseSlipReadingBanks(){
		return !!(this.canShowDepositBankAccounts() && this.slipReading && this.customBanksList && this.customBanksList.length > 0 && this.user);
	},
	shouldUseStandardDepositBanks(){
		return this.canShowDepositBankAccounts() && !this.shouldUseSlipReadingBanks();
	},
	isDepositBankAccountResponse(){
		return !!(
			(this.bungpay && this.bungpayMode === 'TRANSFER' && this.corepayimage === 'bank') ||
			(this.paymentmx && this.corepayimage === 'bank') ||
			(this.fynpay && this.fynpaydata && (this.fynpaydata.bank || this.fynpaydata.account_no))
		);
	},
	isHiddenDepositBankAccountResponse(){
		return !this.canShowDepositBankAccounts() && this.isDepositBankAccountResponse();
	},
	isCorepayEnabled(){
		return !!(this.user && this.bank && this.bank.corepay);
	},
	prepareCorepayDeposit(){
		if(!this.user) return;
		this.paybridge = false;
		this.paybridgeFallback = false;
		for(const provider of ['paymentmx', 'giveaget', 'papaya', 'coolpay', 'onepay', 'nowpay', 'aha', 'fynpay', 'bungpay']){
			this[provider] = false;
			this[provider + 'main'] = false;
		}
		this.corepay = this.isCorepayEnabled();
		this.corepaymain = this.corepay;
	},
	applyDepositAccountVisibilityRules(){
		if(this.canShowDepositBankAccounts()){
			return;
		}
		this.paymentmx = false;
		this.paymentmxmain = false;
		this.fynpay = false;
		this.fynpaymain = false;
		if(this.bungpayMode === 'TRANSFER'){
			this.bungpay = false;
			this.bungpaymain = false;
		}
	},
	getBankImageFromCode(bankName) {
		const bankMap = {
			'SCB': 'scb',
			'KBANK': 'kbank',
			'BBL': 'bankokbank',
			'KTB': 'ktb',
			'BAY': 'krungsri',
			'TTB': 'ttb',
			'GSB': 'gsb',
			'UOB': 'uob',
			'TISCO': 'tisco',
			'KKP': 'kiatnakin',
			'LHBANK': 'lh',
			'IBANK': 'ธนาคารอิสลาม',
			'GHB': 'ghbank',
			'CIMB': 'cimb',
			'BAAC': 'baac',
			'ICBC': 'icbc',
			'HBL': 'hbl',
			'SCBN': 'standard'
		};
		const fileName = bankMap[bankName] || 'kbank';
		try {
			return require('@/assets/images/bank/' + fileName + '.jpg');
		} catch (e) {
			try {
				return require('@/assets/images/bank/' + fileName + '.png');
			} catch (e2) {
				return require('@/assets/images/bank/kbank.jpg');
			}
		}
	},
	setWithdraw2 (value) {
		  if (value === 'plus') {
			  this.deposit_value = (this.deposit_value) ? this.deposit_value + 10 : 10
		  } else if (value === 'minus') {
			  if (this.deposit_value) { this.deposit_value = (this.deposit_value) ? this.deposit_value - 10 : 0 }
		  } else if (value > 0) { this.deposit_value = value } else { this.deposit_value = 0 }
	},
	getGiveagetTransferAmount (value) {
		const amount = Number(value || 0);
		if (!Number.isFinite(amount) || amount <= 0) {
			return 0;
		}
		const rounded = Number(amount.toFixed(2));
		return rounded;
	},
	parseTimeToMinutes(value) {
		const normalized = `${value || ''}`.trim();
		const matched = normalized.match(/^(\d{1,2}):(\d{2})$/);
		if(!matched){
			return null;
		}
		const hours = Number(matched[1]);
		const minutes = Number(matched[2]);
		if(
			!Number.isInteger(hours) ||
			!Number.isInteger(minutes) ||
			hours < 0 ||
			hours > 23 ||
			minutes < 0 ||
			minutes > 59
		){
			return null;
		}
		return (hours * 60) + minutes;
	},
	isWithinDailyTimeWindow(startTime, endTime) {
		const startMinutes = this.parseTimeToMinutes(startTime);
		const endMinutes = this.parseTimeToMinutes(endTime);
		if(startMinutes === null || endMinutes === null){
			return true;
		}
		const now = moment().tz('Asia/Bangkok');
		const currentMinutes = (now.hours() * 60) + now.minutes();
		if(startMinutes === endMinutes){
			return true;
		}
		if(startMinutes < endMinutes){
			return currentMinutes >= startMinutes && currentMinutes < endMinutes;
		}
		return currentMinutes >= startMinutes || currentMinutes < endMinutes;
	},
	shouldShowGiveagetSlipUpload() {
		if(!this.giveaget){
			return false;
		}
		if(!this.bank || !this.bank.giveagetSlipEnabled){
			return false;
		}
		if(!this.bank.giveagetSlipUseTimeWindow){
			return true;
		}
		return this.isWithinDailyTimeWindow(
			this.bank.giveagetSlipStartTime || '23:00',
			this.bank.giveagetSlipEndTime || '02:00'
		);
	},
	async resolveGiveagetDocIdForSlip() {
		if(this.currentGiveagetDocId){
			return this.currentGiveagetDocId;
		}
		const snapshot = await firebase.firestore().collection('giveaget').where('userkey','==',this.user.key).get();
		if(snapshot.empty){
			return '';
		}
		const latestDoc = snapshot.docs
			.map((doc) => ({ id: doc.id, data: doc.data() || {} }))
			.filter((item) => item.data && item.data.successful !== true)
			.sort((left, right) => {
				const leftTime = moment.tz(left.data.createdate || '', 'YYYY-MM-DD HH:mm:ss', 'Asia/Bangkok');
				const rightTime = moment.tz(right.data.createdate || '', 'YYYY-MM-DD HH:mm:ss', 'Asia/Bangkok');
				return rightTime.valueOf() - leftTime.valueOf();
			})[0];
		return latestDoc ? latestDoc.id : '';
	},
	async uploadGiveagetSlip(event){
		const imageData = event.target.files[0];
		if(!imageData){
			return;
		}
		if(!this.shouldShowGiveagetSlipUpload()){
			this.$swal({
				icon: 'error',
				title: 'ส่งสลิป Giveaget',
				text: 'ระบบส่งสลิป Giveaget ยังไม่เปิดในช่วงเวลานี้'
			});
			event.target.value = '';
			return;
		}

		const giveagetDocId = await this.resolveGiveagetDocIdForSlip();
		if(!giveagetDocId){
			this.$swal({
				icon: 'error',
				title: 'ส่งสลิป Giveaget',
				text: 'ไม่พบบิล Giveaget ล่าสุดของท่าน กรุณาสร้างรายการฝากใหม่ก่อน'
			});
			event.target.value = '';
			return;
		}

		this.$store.commit('user/SET_LOADING', true);
		try {
			const resizedImage = await this.resizeImage(imageData, 800, 800);
			const duplicateSnapshot = await firebase.firestore()
				.collection('slip')
				.where('giveaget_doc_id','==',giveagetDocId)
				.get();

			const hasBlockingSlip = duplicateSnapshot.docs.some((doc) => {
				const data = doc.data() || {};
				const uploadStatus = `${data.giveaget_upload_status || ''}`.trim().toUpperCase();
				return (
					['UPLOADING', 'PENDING', 'SUCCESS'].includes(uploadStatus) ||
					['กำลังดำเนินการ', 'ดำเนินการแล้ว'].includes(`${data.status || ''}`.trim())
				);
			});

			if(hasBlockingSlip){
				this.$store.commit('user/SET_LOADING', false);
				this.$swal({
					icon: 'error',
					title: 'ส่งสลิป Giveaget',
					text: 'มีการส่งสลิป Giveaget สำหรับรายการนี้ไปแล้ว'
				});
				event.target.value = '';
				return;
			}

			const slipRef = await firebase.firestore().collection('slip').add({
				userkey:this.user.key,
				code:this.user.code,
				user:{
					code:this.user.code,
					firstname:this.user.firstname,
					lastname:this.user.lastname,
					bank:this.user.bank,
					tel:this.user.tel,
					account_no:this.user.account_no,
					bonus:this.user.bonus,
				},
				createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
				status:'กำลังดำเนินการ',
				provider:'giveaget',
				giveaget_doc_id: giveagetDocId,
				giveaget_order_id: this.currentGiveagetOrderId || '',
			});

			const imagetype = imageData.name.split('.');
			const uploadTask = firebase.storage().ref(`images/slip/${slipRef.id}.${imagetype[imagetype.length-1]}`).put(resizedImage);
			const imageUrl = await new Promise((resolve, reject) => {
				uploadTask.on(`state_changed`,snapshot=>{
					this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
				}, error=>{
					console.log(error.message);
					reject(error);
				},
				async ()=>{
					try{
						const url = await uploadTask.snapshot.ref.getDownloadURL();
						await firebase.firestore().collection('slip').doc(slipRef.id).update({
							image:url,
						});
						resolve(url);
					}catch(uploadError){
						reject(uploadError);
					}
				});
			});
			if(!imageUrl){
				throw new Error('ไม่พบ URL ของสลิปหลังอัปโหลด');
			}

			const uploadResponse = await axios.post(`https://api.deltaplus-dp.com/giveaget/upload_slip/${slipRef.id}`);
			this.$store.commit('user/SET_LOADING', false);
			if(uploadResponse.data && uploadResponse.data.success){
				this.$swal({
					icon: 'success',
					title: 'ส่งสลิป Giveaget แล้ว',
					text: 'ระบบส่งสลิปให้ Giveaget แล้ว กรุณารอผลตรวจสอบและ callback'
				});
			}else{
				this.$swal({
					icon: 'error',
					title: 'ส่งสลิป Giveaget ไม่สำเร็จ',
					text: (uploadResponse.data && uploadResponse.data.error) ? uploadResponse.data.error : 'โปรดติดต่อ admin'
				});
			}
		}catch(error){
			this.$store.commit('user/SET_LOADING', false);
			this.$swal({
				icon: 'error',
				title: 'ส่งสลิป Giveaget ไม่สำเร็จ',
				text: error && error.response && error.response.data && error.response.data.error ? error.response.data.error : 'โปรดติดต่อ admin'
			});
		}
		event.target.value = '';
	},
	genQrCodeCorePay(){
		if(!this.isCorepayEnabled()) return;
		
		this.prepareCorepayDeposit();
		if (this.isProcessing) return;
		this.isProcessing = true;
		if(this.paybridge && !this.paybridgeFallback){
			this.checkPayBridgeDeposit();
			return;
		}
		
		if(this.papayamain && this.corepaymain){
			if(this.deposit_value < 300) this.papaya = false; else this.corepay = false;
		}else if(this.papayamain && this.coolpaymain){
			if(this.deposit_value < 300) this.papaya = false; else this.coolpay = false;
		}
		if(this.giveagetmain && this.paymentmxmain){
			if(this.deposit_value < 100) this.giveaget = false; else this.paymentmx = false;
		}
		if(this.giveagetmain && this.corepaymain){
			if(this.deposit_value < 100) this.giveaget = false; else this.corepay = false;
		}
		if(this.onepaymain && this.corepaymain){
			if(this.deposit_value < 300) this.onepay = false; else this.corepay = false;
		}else if(this.onepaymain && this.coolpaymain){
			if(this.deposit_value < 300) this.onepay = false; else this.coolpay = false;
		}
		if(this.ahamain && this.corepaymain){
			if(this.deposit_value < 100) this.aha = false; else this.corepay = false;
		}
		if(this.fynpaymain && this.corepaymain){
			if(this.deposit_value < 100) this.fynpay = false; else this.corepay = false;
		}
		if(this.bungpay){
			this.$store.commit('user/SET_LOADING', true)
			firebase.firestore().collection('papaya').add({
				userkey:this.user.key,
				code:this.user.code,
				createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
				status:false,
				amount:this.deposit_value,
			}).then(async (result)=>{
				this.unsubscribe = firebase.firestore().collection('papaya').doc(result.id).onSnapshot(async (doc) => {
				if(doc.data().bungpay && doc.data().successful){
					this.$store.commit('user/SET_LOADING', false)
					this.isProcessing = false;
					this.$swal({ icon: 'success', title: 'Success', text: `แจ้งฝากพร้อมเพย์เรียบร้อย`})
					this.unsubscribe()
					$("#depositModal").modal('hide')
				}else
				if(doc.data().bungpay && doc.data().status){
					if(this.bungpayMode === 'TRANSFER'){
						this.bungpayBank = {
							bankAccountNumber: doc.data().bankAccountNumber || '',
							bankAccountName: doc.data().bankAccountName || '',
							bankName: doc.data().bankName || '',
							bankCode: doc.data().bankCode || '',
							depositAmount: doc.data().depositAmount || 0
						};
						this.corepayimage = 'bank';
					} else {
						this.corepayimage = doc.data().bungpay.payurl;
					}
					this.unsubscribe()
					this.isProcessing = false;
				}
				else if(doc.data().bungpay && !doc.data().status){
					this.$store.commit('user/SET_LOADING', false)
					this.isProcessing = false;
					if(doc.data().bungpay)
					this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: '\nโปรดติดต่อ admin'}).then((result) => {
					});
					this.unsubscribe()
				}
				});
				axios.get(`https://api.deltaplus-dp.com/apx2sx/${result.id}`).then((result)=>{
				this.$store.commit('user/SET_LOADING', false)
				}).catch((error) => {
				this.$store.commit('user/SET_LOADING', false)
				this.isProcessing = false;
				})
			}).catch((error) => {
				this.$store.commit('user/SET_LOADING', false)
			})
		}else
		if(this.giveaget){
			if(this.deposit_value < 100){
				this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์', text: `จำนวนเงินต้องฝากขั้นต่ำ 100 บาท`}).then(() => {
					this.isProcessing = false;
				});
			}else{
				this.$store.commit('user/SET_LOADING', true)
				this.giveagetTransferAmount = this.getGiveagetTransferAmount(this.deposit_value)
				this.currentGiveagetDocId = ''
				this.currentGiveagetOrderId = ''
				firebase.firestore().collection('giveaget').add({
					userkey:this.user.key,
					code:this.user.code,
					createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
					status:false,
					qty:this.deposit_value,
				}).then(async (result)=>{
					this.currentGiveagetDocId = result.id
					this.unsubscribe = firebase.firestore().collection('giveaget').doc(result.id).onSnapshot(async (doc) => {
						if(!doc.exists){
							return;
						}
						const giveagetData = doc.data();
						if(giveagetData && giveagetData.giveaget_order_id){
							this.currentGiveagetOrderId = giveagetData.giveaget_order_id;
						}
						if(giveagetData.successful){
							this.$store.commit('user/SET_LOADING', false)
							this.$swal({ icon: 'success', title: 'Success', text: `แจ้งฝากพร้อมเพย์เรียบร้อย`})
							if(this.unsubscribe){
								this.unsubscribe()
								this.unsubscribe = null
							}
							$("#depositModal").modal('hide')
							this.isProcessing = false;
						}else if(giveagetData.qr_image_url && giveagetData.status){
							this.giveagetTransferAmount = Number(giveagetData.amount || this.getGiveagetTransferAmount(this.deposit_value))
							this.corepayimage = giveagetData.qr_image_url;
							this.$store.commit('user/SET_LOADING', false)
							this.isProcessing = false;
						}else if(giveagetData.error){
							this.$store.commit('user/SET_LOADING', false)
							this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: giveagetData.error})
							if(this.unsubscribe){
								this.unsubscribe()
								this.unsubscribe = null
							}
							this.isProcessing = false;
						}
					});
					axios.get(`https://api.deltaplus-dp.com/giveaget/${result.id}`).then(()=>{
						this.$store.commit('user/SET_LOADING', false)
					}).catch(() => {
						this.$store.commit('user/SET_LOADING', false)
						this.isProcessing = false;
					})
				}).catch(() => {
					this.$store.commit('user/SET_LOADING', false)
					this.isProcessing = false;
				})
			}
		}else
		if(this.paymentmx){
			if(this.deposit_value >= 50){
				this.$store.commit('user/SET_LOADING', true)
				firebase.firestore().collection('paymentmx').add({
					userkey:this.user.key,
					code:this.user.code,
					createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
					status:false,
					qty:this.deposit_value,
				}).then(async (result)=>{
					this.unsubscribe = firebase.firestore().collection('paymentmx').doc(result.id).onSnapshot(async (doc) => {
						if(doc.data().account_bank_code && doc.data().status){
						// BANK_TRANSFER: เก็บข้อมูลธนาคารแทน QR
						this.paymentmxBank = {
							bank_code: doc.data().account_bank_code,
							bank_no: doc.data().account_bank_no,
							bank_name: doc.data().account_bank_name,
							account_name: doc.data().account_name, // ชื่อเจ้าของบัญชี
							amount: doc.data().amount
						};
						this.corepayimage = 'bank'; // flag ให้แสดงข้อมูลธนาคาร
						this.unsubscribe()
						this.isProcessing = false;
						}else if(doc.data().error){
						this.$store.commit('user/SET_LOADING', false)
						this.$swal({ icon: 'error', title: 'แจ้งฝากโอนเงินมีปัญหา', text: doc.data().error})
						this.unsubscribe()
						this.isProcessing = false;
						}
					});
					axios.get(`https://api.deltaplus-dp.com/paymentmx/${result.id}`).then(()=>{
						this.$store.commit('user/SET_LOADING', false)
					})
				})
			}else{
				this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์', text: `จำนวนเงินต้องมากกว่า 50 บาท`}).then(() => {
					this.isProcessing = false;
				});
			}
		}else
		if(this.onepay){
			if(this.deposit_value < 300){
			this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์', text: `จำนวนเงินต้องมากกว่า 300 บาท`}).then((result) => {
				this.isProcessing = false;
			});
			}else{
			this.$store.commit('user/SET_LOADING', true)
			firebase.firestore().collection('papaya').add({
					userkey:this.user.key,
					code:this.user.code,
					createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
					status:false,
					amount:this.deposit_value,
				}).then(async (result)=>{
					this.unsubscribe = firebase.firestore().collection('papaya').doc(result.id).onSnapshot(async (doc) => {
					if(doc.data().papaya && doc.data().status){
						this.corepayimage = doc.data().papaya.payurl;
						this.unsubscribe()
						this.isProcessing = false;
					}else if(doc.data().papaya && !doc.data().status){
						this.$store.commit('user/SET_LOADING', false)
						if(doc.data().papaya)
						this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: '\nโปรดติดต่อ admin'}).then((result) => {
							this.isProcessing = false;
						});
						this.unsubscribe()
					}else if(doc.data().papaya && doc.data().status){
						this.$store.commit('user/SET_LOADING', false)
						this.$swal({ icon: 'success', title: 'Success', text: `แจ้งฝากพร้อมเพย์เรียบร้อย`})
						this.unsubscribe()
						$("#depositModal").modal('hide')
						this.isProcessing = false;
					}
					});
					axios.get(`https://api.deltaplus-dp.com/onepay/${result.id}`).then((result)=>{
					this.$store.commit('user/SET_LOADING', false)
					})
				})
			}
		}else
		if(this.nowpay && this.deposit_value >= 300){
			if(this.deposit_value < 100){
			this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์', text: `จำนวนเงินต้องมากกว่า 100 บาท`}).then((result) => {
				this.isQrCodeLoading = false;
			});
			}else{
			this.$store.commit('user/SET_LOADING', true)
			firebase.firestore().collection('papaya').add({
				userkey:this.user.key,
				code:this.user.code,
				createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
				status:false,
				amount:this.deposit_value,
			}).then(async (result)=>{
				this.unsubscribe = firebase.firestore().collection('papaya').doc(result.id).onSnapshot(async (doc) => {
				if(doc.data().nowpay && doc.data().status){
				this.corepayimage = doc.data().nowpay.payment_url;
				console.log('this.corepayimage',this.corepayimage);
				this.unsubscribe()
				this.isQrCodeLoading = false;
				}else if(doc.data().nowpay && doc.data().status !== 'PENDING'){
				this.$store.commit('user/SET_LOADING', false)
				if(doc.data().nowpay)
				this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: '\nโปรดติดต่อ admin'}).then((result) => {
					this.isQrCodeLoading = false;
				});
				this.unsubscribe()
				}else if(doc.data().nowpay && doc.data().status && doc.data().successful){
				this.$store.commit('user/SET_LOADING', false)
				this.$swal({ icon: 'success', title: 'Success', text: `แจ้งฝากพร้อมเพย์เรียบร้อย`})
				this.unsubscribe()
				$("#depositModal").modal('hide')
				this.isQrCodeLoading = false;
				}else if(doc.data().error){
				this.isQrCodeLoading = false;
				this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์', text: doc.data().error}).then((result) => {
				});
				this.unsubscribe()
				}
				});
				axios.get(`https://api.deltaplus-dp.com/nowpay/qrcode/${result.id}`).then((result)=>{
				this.$store.commit('user/SET_LOADING', false)
				})
			})
			}
		}else
		if(this.papaya){
			if(this.deposit_value < 300){
			this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์', text: `จำนวนเงินต้องมากกว่า 300 บาท`}).then((result) => {
				this.isProcessing = false;
			});
			}else{
			this.$store.commit('user/SET_LOADING', true)
			firebase.firestore().collection('papaya').add({
					userkey:this.user.key,
					code:this.user.code,
					createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
					status:false,
					amount:this.deposit_value,
				}).then(async (result)=>{
					this.unsubscribe = firebase.firestore().collection('papaya').doc(result.id).onSnapshot(async (doc) => {
					if(doc.data().papaya && doc.data().status){
						this.corepayimage = doc.data().papaya.payurl;
						this.unsubscribe()
						this.isProcessing = false;
					}else if(doc.data().papaya && !doc.data().status){
						this.$store.commit('user/SET_LOADING', false)
						if(doc.data().papaya)
						this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: '\nโปรดติดต่อ admin'}).then((result) => {
							this.isProcessing = false;
						});
						this.unsubscribe()
					}else if(doc.data().papaya && doc.data().status){
						this.$store.commit('user/SET_LOADING', false)
						this.$swal({ icon: 'success', title: 'Success', text: `แจ้งฝากพร้อมเพย์เรียบร้อย`})
						this.unsubscribe()
						$("#depositModal").modal('hide')
						this.isProcessing = false;
					}
					});
					axios.get(`https://api.deltaplus-dp.com/sonic/${result.id}`).then((result)=>{
					this.$store.commit('user/SET_LOADING', false)
					})
				})
			}
		}else
		if(this.coolpay){
			if(this.deposit_value < 100){
				this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์', text: `จำนวนเงินต้องมากกว่า 100 บาท`}).then((result) => {
					this.isProcessing = false;
				});
			}else{
				this.$store.commit('user/SET_LOADING', true)
				firebase.firestore().collection('papaya').add({
					userkey:this.user.key,
					code:this.user.code,
					createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
					status:false,
					amount:this.deposit_value,
				}).then(async (result)=>{
					this.unsubscribe = firebase.firestore().collection('papaya').doc(result.id).onSnapshot(async (doc) => {
					if(doc.data().papaya && doc.data().status){
						this.corepayimage = doc.data().papaya.invoice_url;
						this.unsubscribe()
						this.isProcessing = false;
					}else if(doc.data().papaya && !doc.data().status){
						this.$store.commit('user/SET_LOADING', false)
						if(doc.data().papaya)
						this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: '\nโปรดติดต่อ admin'}).then((result) => {
							this.isProcessing = false;
						});
						this.unsubscribe()
					}else if(doc.data().papaya && doc.data().status && doc.data().successful){
						this.$store.commit('user/SET_LOADING', false)
						this.$swal({ icon: 'success', title: 'Success', text: `แจ้งฝากพร้อมเพย์เรียบร้อย`})
						this.unsubscribe()
						$("#depositModal").modal('hide')
						this.isProcessing = false;
					}
					});
					axios.get(`https://api.deltaplus-dp.com/coolpay/${result.id}`).then((result)=>{
						this.$store.commit('user/SET_LOADING', false)
					})
				})
			}
		}else
		if(this.aha){
			this.$store.commit('user/SET_LOADING', true)
			firebase.firestore().collection('papaya').add({
				userkey:this.user.key,
				code:this.user.code,
				createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
				status:false,
				amount:this.deposit_value,
			}).then(async (result)=>{
				this.unsubscribe = firebase.firestore().collection('papaya').doc(result.id).onSnapshot(async (doc) => {
				if(doc.data().aha && doc.data().successful){
					this.$store.commit('user/SET_LOADING', false)
					this.isProcessing = false;
					this.$swal({ icon: 'success', title: 'Success', text: `แจ้งฝากพร้อมเพย์เรียบร้อย`})
					this.unsubscribe()
					$("#depositModal").modal('hide')
				}else
				if(doc.data().aha && doc.data().status){
					this.corepayimage = doc.data().aha.payurl;
					this.unsubscribe()
					this.isGeneratingQrCode = false;
				}else if(doc.data().aha && !doc.data().status){
					this.$store.commit('user/SET_LOADING', false)
					this.isProcessing = false;
					if(doc.data().aha)
						this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: '\nโปรดติดต่อ admin'}).then((result) => {
					});
					this.unsubscribe()
					this.isGeneratingQrCode = false;
				}
				});
				axios.get(`https://api.deltaplus-dp.com/aha/${result.id}`).then((result)=>{
				this.$store.commit('user/SET_LOADING', false)
				}).catch((error) => {
				this.$store.commit('user/SET_LOADING', false)
				this.isProcessing = false;
				})
			}).catch((error) => {
				this.$store.commit('user/SET_LOADING', false)
				this.isProcessing = false;
				this.$swal({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: 'ไม่สามารถสร้าง QR Code ได้ กรุณาลองใหม่อีกครั้ง' });
			})
		}else
		if(this.fynpay && this.deposit_value >= 100){
			this.$store.commit('user/SET_LOADING', true)
			firebase.firestore().collection('papaya').add({
				userkey:this.user.key,
				code:this.user.code,
				createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
				status:false,
				amount:this.deposit_value,
			}).then(async (result)=>{
				this.unsubscribe = firebase.firestore().collection('papaya').doc(result.id).onSnapshot(async (doc) => {
					if(doc.data().fynpay && doc.data().fynpay.message === 'Success'){
						this.fynpay = true;
						this.fynpaydata.bank = doc.data().fynpay.bankImage;
						this.fynpaydata.account_no = doc.data().fynpay.transaction.accountNumber;
						if(this.user.bank === 'kbank'){
							this.fynpaydata.requestedAmount = doc.data().fynpay.transaction.requestedAmount;
						}
						this.corepayimage = '123';
						this.isProcessing = false;
						// ไม่ unsubscribe ที่นี่ เพื่อให้ listener ทำงานต่อไปรอ successful
					}
					
					if(doc.data().successful){
						// ยกเลิก timeout เพราะสำเร็จแล้ว
						if(this.fynpayTimeout){
							clearTimeout(this.fynpayTimeout);
							this.fynpayTimeout = null;
						}
						this.$store.commit('user/SET_LOADING', false)
						this.$swal({ icon: 'success', title: 'Success', text: `แจ้งฝากพร้อมเพย์เรียบร้อย`})
						this.unsubscribe()
						$("#depositModal").modal('hide')
						this.isQrCodeLoading = false;
					}
				});
				
				// ตั้ง timeout 15 นาที (900000ms) เพื่อ unsubscribe อัตโนมัติ
				this.fynpayTimeout = setTimeout(() => {
					if(this.unsubscribe){
						this.unsubscribe();
						this.unsubscribe = null;
					}
					this.fynpayTimeout = null;
				}, 900000);
				axios.get(`https://api.deltaplus-dp.com/fynpay/${result.id}`).then((result)=>{
					this.$store.commit('user/SET_LOADING', false)
				})
			})
		}else
			if(this.deposit_value >= 50){
				this.$store.commit('user/SET_LOADING', true)
				this.corepayBankTransfer = null;
				this.corepayimage = '';
				firebase.firestore().collection('corepay').add({
			userkey:this.user.key,
			code:this.user.code,
			createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
				status:false,
				amount:this.deposit_value,
				corepay_payment_mode:this.corepayPaymentMode,
				}).then(async (result)=>{
				this.unsubscribe = firebase.firestore().collection('corepay').doc(result.id).onSnapshot(async (doc) => {
					if(!doc.exists) return;
					const corepayData = doc.data() || {};
					if(corepayData.corepay && corepayData.status){
						const paymentMode = this.normalizeCorepayPaymentMode(corepayData.corepay_payment_mode || this.corepayPaymentMode);
						if(paymentMode === 'account'){
							this.corepayBankTransfer = this.normalizeCorepayBankTransfer(corepayData.corepay);
							this.corepayimage = '';
						}else{
							this.corepayBankTransfer = null;
							this.corepayimage = corepayData.corepay.redirect;
						}
					this.$store.commit('user/SET_LOADING', false)
					if(this.unsubscribe){
						this.unsubscribe()
						this.unsubscribe = null
					}
					this.isProcessing = false;
					}else if(corepayData.corepay && !corepayData.status){
					this.$store.commit('user/SET_LOADING', false)
					this.$swal({ icon: 'error', title: 'แจ้งฝาก Corepay มีปัญหา', text: (corepayData.corepay.message || 'โปรดติดต่อ admin')+'\nไม่สามารถฝากซ้ำได้โปรดรอ 5 นาทีแล้วแจ้งฝากใหม่'}).then((result) => {
						this.isProcessing = false;
					});
					if(this.unsubscribe){
						this.unsubscribe()
						this.unsubscribe = null
					}
				}
			});
			axios.get(`https://api.deltaplus-dp.com/api/repay/${result.id}`).then((result)=>{
				this.$store.commit('user/SET_LOADING', false)
			})
			})
		}else{
			this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์', text: `จำนวนเงินต้องมากกว่า 50 บาท`}).then((result) => {
				this.isProcessing = false;
			});
		}
	  this.papaya = this.papayamain
	  this.corepay = this.corepaymain
	  this.paymentmx = this.paymentmxmain
	  this.giveaget = this.giveagetmain
	  this.coolpay = this.coolpaymain
	  this.onepay = this.onepaymain
	  this.fynpay = this.fynpaymain
	  this.bungpay = this.bungpaymain
    },
    showCorepayPage(){
      if(!this.isCorepayEnabled()) return;
      if(this.corepaypage)
        this.corepaypage = false;
      else
        this.corepaypage = true;
    },
	getLevelImage(){
		if(this.user.level){
			return require(`../assets/images/level/shiba-head-level${this.user.level}.png`)
		}else{
			return require('../assets/images/level/shiba-head-level1.png')
		}
	},
	getLevelImage2(){
		if(this.user.level){
			return require(`../assets/images/level/shiba-body-level${this.user.level}.png`)
		}else{
			return require('../assets/images/level/shiba-body-level1.png')
		}
	},
	showDateTime(date){
		return moment(date,'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY HH:mm');
	},
	async closeAnnouncement(type){
		if(type===1){
			firebase.database().ref(`/announcement_users/${this.user.key}`).update({
				status:'รับทราบแล้ว',
				updatetime:moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
			});
		}
		document.getElementById("an-close").click();
	},
	async getAnnouncementUser(key){
		if(key){
			const announcement = (await firebase.database().ref(`/announcement_users/${key}`).once('value')).val();
			if(announcement && !announcement.close && announcement.title && (!announcement.status || announcement.status!=='รับทราบแล้ว')){
				this.announcement_user = announcement;
				document.getElementById("a-modal").click();
			}
		}
	},
	resizeImage(file, maxWidth = 800, maxHeight = 800) {
		return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = (event) => {
			const img = new Image();
			img.onload = () => {
			let width = img.width;
			let height = img.height;

			// คำนวณขนาดใหม่
			if (width > maxWidth || height > maxHeight) {
				if (width / height > maxWidth / maxHeight) {
				height = Math.round((height * maxWidth) / width);
				width = maxWidth;
				} else {
				width = Math.round((width * maxHeight) / height);
				height = maxHeight;
				}
			}

			const canvas = document.createElement('canvas');
			canvas.width = width;
			canvas.height = height;
			const ctx = canvas.getContext('2d');
			ctx.drawImage(img, 0, 0, width, height);

			canvas.toBlob((blob) => {
				resolve(blob);
			}, file.type, 0.85); // 0.85 คือ quality (jpeg/png)
			};
			img.onerror = reject;
			img.src = event.target.result;
		};
		reader.onerror = reject;
		reader.readAsDataURL(file);
		});
	},
	async uploadSlip(event){
		if(PAYBRIDGE_FRONTEND_ENABLED && this.paybridgeMatch){
			return this.uploadPayBridgeSlip(event);
		}
		if(this.shouldShowGiveagetSlipUpload()){
			return this.uploadGiveagetSlip(event);
		}
		const imageData = event.target.files[0];
		if(!imageData){
			return;
		}
		this.$store.commit('user/SET_LOADING', true)
		const resizedImage = await this.resizeImage(imageData, 800, 800);
		await firebase.firestore().collection('slip').where('userkey','==',this.user.key).where('status','==','กำลังดำเนินการ').get().then((result)=>{
			if(result.empty){
				firebase.firestore().collection('slip').add({
					userkey:this.user.key,
					code:this.user.code,
					user:{
						code:this.user.code,
						firstname:this.user.firstname,
						lastname:this.user.lastname,
						bank:this.user.bank,
						tel:this.user.tel,
						account_no:this.user.account_no,
						bonus:this.user.bonus,
					},
					createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
					status:'กำลังดำเนินการ',
				}).then(async (result)=>{
					const imagetype = imageData.name.split('.');
					const storageRef = firebase.storage().ref(`images/slip/${result.id}.${imagetype[imagetype.length-1]}`).put(resizedImage);
					await storageRef.on(`state_changed`,snapshot=>{
						this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
					}, error=>{console.log(error.message)},
					()=>{
						storageRef.snapshot.ref.getDownloadURL().then((url)=>{
							firebase.firestore().collection('slip').doc(result.id).update({
								image:url,
							})
						});
					});
					this.$store.commit('user/SET_LOADING', false)
					this.$swal({ icon: 'success', title: 'แจ้งสลิปเรียบร้อย', text: `ทีมงานขออภัยในความล่าช้าและจะรีบดำเนินการให้โดยเร็วที่สุด`}).then((result) => {
					});
				})
			}else{
				this.$store.commit('user/SET_LOADING', false)
				this.$swal({ icon: 'error', title: 'แจ้งสลิป', text: `ทีมงานกำลังตรวจสอบสลิปของท่านก่อนหน้าและจะรีบดำเนินการให้โดยเร็วที่สุด`}).then((result) => {
				});
			}
		});
		
	},
	openBrowseFile(){
		const fileInput = document.getElementById('my_file');
		if(fileInput){
			fileInput.value = '';
    		fileInput.click();
		}
	},
	openBrowsePayBridgeFile(){
		const input = document.getElementById('my_file_paybridge');
		if(input) input.click();
	},
	acknowledgePayBridgeTerms(){
		this.paybridgeAcknowledged = true;
		this.persistPayBridgeTask();
	},
	getPayBridgeTaskStorageKey(){
		let userKey = this.user && (this.user.key || this.user.code);
		if(!userKey){
			try{
				const userData = JSON.parse(localStorage.getItem('userData') || '{}');
				userKey = userData.key || userData.code || 'guest';
			}catch(error){
				userKey = 'guest';
			}
		}
		return `deltaplus_paybridge_task_${userKey}`;
	},
	isPayBridgeTaskExpired(match = this.paybridgeMatch){
		if(!match) return true;
		if(!match.expiresAt) return false;
		const expiresAtMs = Date.parse(match.expiresAt);
		return !!expiresAtMs && expiresAtMs <= this.paybridgeNow;
	},
	persistPayBridgeTask(){
		if(!this.paybridgeMatch || this.isPayBridgeTaskExpired()) return;
		const payload = {
			match: this.paybridgeMatch,
			localDepositId: this.paybridgeLocalDepositId || '',
			depositValue: this.deposit_value || '',
			acknowledged: !!this.paybridgeAcknowledged,
			savedAt: Date.now(),
		};
		localStorage.setItem(this.getPayBridgeTaskStorageKey(), JSON.stringify(payload));
	},
	restorePayBridgeTask(){
		try{
			const raw = localStorage.getItem(this.getPayBridgeTaskStorageKey());
			if(!raw) return false;
			const payload = JSON.parse(raw);
			if(!payload || !payload.match || this.isPayBridgeTaskExpired(payload.match)){
				localStorage.removeItem(this.getPayBridgeTaskStorageKey());
				return false;
			}
			this.paybridgeMatch = payload.match;
			this.paybridgeLocalDepositId = payload.localDepositId || '';
			this.deposit_value = payload.depositValue || this.deposit_value;
			this.paybridgeAcknowledged = !!payload.acknowledged;
			this.paybridgeFallback = false;
			this.paybridgeMessage = '';
			this.paybridgeExpiredNotified = false;
			return true;
		}catch(error){
			localStorage.removeItem(this.getPayBridgeTaskStorageKey());
			return false;
		}
	},
	clearPayBridgeTask(){
		localStorage.removeItem(this.getPayBridgeTaskStorageKey());
		this.paybridgeMatch = null;
		this.paybridgeLocalDepositId = '';
		this.paybridgeMessage = '';
		this.paybridgeAcknowledged = false;
		this.paybridgeExpiredNotified = false;
	},
	expirePayBridgeTaskIfNeeded(){
		if(!this.paybridgeMatch || !this.isPayBridgeTaskExpired()) return;
		const wasModalOpen = $('#depositModal').hasClass('show');
		this.clearPayBridgeTask();
		if(wasModalOpen){
			$("#depositModal").modal('hide');
			this.$swal({ icon: 'warning', title: 'PayBridge หมดเวลา', text: 'รายการนี้หมดเวลาแล้ว กรุณาเริ่มฝากใหม่อีกครั้ง' });
		}
	},
	reopenPayBridgeTask(){
		if(!this.restorePayBridgeTask() || this.isPayBridgeTaskExpired()){
			this.clearPayBridgeTask();
			this.$swal({ icon: 'warning', title: 'PayBridge หมดเวลา', text: 'รายการนี้หมดเวลาแล้ว กรุณาเริ่มฝากใหม่อีกครั้ง' });
			return;
		}
		this.corepaypage = true;
		this.paybridgeFallback = false;
		$("#depositModal").modal('show');
	},
	async cancelPayBridgeTask(){
		const result = await this.$swal({
			icon: 'question',
			title: 'ยกเลิกรายการ PayBridge?',
			text: 'หากยกเลิกแล้วต้องเริ่มฝากใหม่อีกครั้ง',
			showCancelButton: true,
			confirmButtonText: 'ยืนยันยกเลิก',
			cancelButtonText: 'กลับไปอัปโหลดสลิป',
		});
		if(!result.isConfirmed) return;
		try{
			const currentUser = firebase.auth().currentUser;
			if(!currentUser) throw new Error('กรุณาเข้าสู่ระบบใหม่');
			const token = await currentUser.getIdToken();
			const response = await axios.post(`${this.getPayBridgeApiBase()}/paybridge/deposit/cancel`, {
				localDepositId: this.paybridgeLocalDepositId,
				userKey: this.user.key,
				reason: 'CUSTOMER_CANCELLED',
			}, {
				timeout: 15000,
				headers: { Authorization: `Bearer ${token}` },
			});
			if(response.data && response.data.ok === false){
				throw new Error(response.data.error || 'ยกเลิกรายการไม่สำเร็จ');
			}
			this.clearPayBridgeTask();
			this.paybridgeFallback = false;
			this.corepaypage = false;
			$("#depositModal").modal('hide');
		}catch(error){
			this.$swal({
				icon: 'error',
				title: 'ยังยกเลิกรายการไม่ได้',
				text: error && error.response && error.response.data
					? (error.response.data.error || error.response.data.message || 'กรุณาลองใหม่')
					: (error.message || 'กรุณาลองใหม่'),
			});
		}
	},
	async uploadPayBridgeSlip(event){
		const imageData = event.target.files[0];
		if(!imageData || !this.paybridgeMatch){
			return;
		}
		this.$store.commit('user/SET_LOADING', true);
		try{
			const pending = await firebase.firestore().collection('slip').where('userkey','==',this.user.key).where('status','==','กำลังดำเนินการ').get();
			if(!pending.empty){
				this.$store.commit('user/SET_LOADING', false);
				this.$swal({ icon: 'error', title: 'แจ้งสลิป', text: `ทีมงานกำลังตรวจสอบสลิปของท่านก่อนหน้าและจะรีบดำเนินการให้โดยเร็วที่สุด`});
				return;
			}
			const resizedImage = await this.resizeImage(imageData, 800, 800);
			const match = this.paybridgeMatch;
			const recipientAccount = match.recipientAccount || {};
			const amountMinor = match.amountMinor || Math.round(Number(this.deposit_value || 0) * 100);
			const slipRef = await firebase.firestore().collection('slip').add({
				userkey:this.user.key,
				code:this.user.code,
				user:{
					code:this.user.code,
					firstname:this.user.firstname,
					lastname:this.user.lastname,
					bank:this.user.bank,
					account_no:this.user.account_no,
					bonus:this.user.bonus,
				},
				firstname:this.user.firstname,
				lastname:this.user.lastname,
				bank:this.user.bank,
				account_no:this.user.account_no,
				createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
				status:'กำลังดำเนินการ',
				provider:'paybridge',
				paybridge_match_id: match.matchId,
				paybridge_deposit_id: match.depositId || '',
				paybridge_withdrawal_id: match.withdrawalId || '',
				paybridge_local_deposit_id: this.paybridgeLocalDepositId || '',
				paybridge_amount_minor: amountMinor,
				paybridge_amount: amountMinor / 100,
				paybridge_recipient_account: recipientAccount,
			});
			const imagetype = imageData.name.split('.');
			const extension = imagetype.length > 1 ? imagetype[imagetype.length-1] : 'jpg';
			const storagePath = `images/slip/paybridge/${slipRef.id}.${extension}`;
			const uploadTask = firebase.storage().ref(storagePath).put(resizedImage);
			let slipImageUrl = '';
			await new Promise((resolve, reject) => {
				uploadTask.on('state_changed', snapshot => {
					this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
				}, error => {
					reject(error);
				}, async () => {
					try{
						const url = await uploadTask.snapshot.ref.getDownloadURL();
						slipImageUrl = url;
						await firebase.firestore().collection('slip').doc(slipRef.id).update({
							image:url,
							storagePath,
						});
						resolve();
					}catch(error){
						reject(error);
					}
				});
			});
			const currentUser = firebase.auth().currentUser;
			if(!currentUser) throw new Error('กรุณาเข้าสู่ระบบใหม่');
			const token = await currentUser.getIdToken();
			const response = await axios.post(`${this.getPayBridgeApiBase()}/paybridge/slip/submit`, {
				slipId: slipRef.id,
				localDepositId: this.paybridgeLocalDepositId || '',
				matchId: match.matchId,
				slipStoragePath: storagePath,
				slipImageUrl,
			}, {
				timeout: 20000,
				headers: { Authorization: `Bearer ${token}` },
			});
			const submitResult = response.data || {};
			if(submitResult.ok === false || submitResult.status === false){
				throw new Error(submitResult.error || 'PayBridge submit failed');
			}
			await firebase.firestore().collection('slip').doc(slipRef.id).update({
				paybridge_submitted: true,
				paybridge_submit_status: submitResult.status || '',
				paybridge_verification_id: submitResult.verificationId || '',
				paybridge_submitted_at: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
			});
			this.$swal({ icon: 'success', title: 'แจ้งสลิปเรียบร้อย', text: `ระบบจะตรวจสลิปและเติมเครดิตหลังยืนยันสำเร็จ`});
			this.clearPayBridgeTask();
			$("#depositModal").modal('hide');
		}catch(error){
			this.$swal({ icon: 'error', title: 'แจ้งสลิป', text: error && error.message ? error.message : 'อัพโหลดสลิปไม่สำเร็จ' });
		}finally{
			this.$store.commit('user/SET_LOADING', false);
			if(event && event.target) event.target.value = '';
		}
	},
	shouldShowLocalDepositBanks(){
		return !this.paybridge || this.paybridgeFallback;
	},
	getPayBridgeApiBase(){
		return 'https://api.deltaplus-dp.com';
	},
	isTrueWalletBank(bankCode){
		const normalized = (bankCode || '').toString().toLowerCase().replace(/[\s_-]/g, '');
		return ['truewallet', 'truemoney', 'truemoneywallet', 'wallet'].includes(normalized);
	},
	isPayBridgeBankAccount(account){
		if(!account) return false;
		return !!account.accountNo && !this.isTrueWalletBank(account.bankCode || account.bankName);
	},
	isPayBridgeAllowedUser(){
		if(!PAYBRIDGE_ALLOWED_USER_CODES.length) return true;
		const code = (this.user && this.user.code ? this.user.code : '').toString().trim().toUpperCase();
		return PAYBRIDGE_ALLOWED_USER_CODES.includes(code);
	},
	normalizePayBridgeBankCode(bankCode){
		const normalized = (bankCode || '').toString().toLowerCase();
		const aliases = { bbl: 'bankokbank', bay: 'krungsri', kbank: 'kbank', scb: 'scb', ktb: 'ktb', ttb: 'ttb', gsb: 'gsb' };
		return aliases[normalized] || normalized || 'kbank';
	},
	getPayBridgeBankImage(bankCode) {
		const fileName = this.normalizePayBridgeBankCode(bankCode);
		try { return require('@/assets/images/bank/' + fileName + '.jpg'); } catch (e) { try { return require('@/assets/images/bank/' + fileName + '.png'); } catch (e2) { return require('@/assets/images/bank/kbank.jpg'); } }
	},
	isLocalPayBridgeTestMode(){
		return (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') && window.location.port === '8089';
	},
	async checkPayBridgeDeposit(){
		if(!PAYBRIDGE_FRONTEND_ENABLED || !this.isPayBridgeAllowedUser()){
			this.paybridge = false;
			this.paybridgeFallback = true;
			this.paybridgeAcknowledged = false;
			this.isProcessing = false;
			return;
		}
		if(this.hasActivePayBridgeTask){
			this.reopenPayBridgeTask();
			this.isProcessing = false;
			return;
		}
		if(this.paybridgeChecking) return;
		if(!this.deposit_value || Number(this.deposit_value) < 100){
			this.$swal({ icon: 'error', title: 'แจ้งฝาก', text: `จำนวนเงินต้องฝากขั้นต่ำ 100 บาท`});
			this.isProcessing = false;
			return;
		}
		this.clearPayBridgeTask();
		const localDepositId = `deltaplus-deposit-${this.user.key}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
		this.paybridgeLocalDepositId = localDepositId;
		this.paybridgeChecking = true;
		this.paybridgeMatch = null;
		this.paybridgeAcknowledged = false;
		this.paybridgeMessage = '';
		this.$store.commit('user/SET_LOADING', true);
		try{
			const currentUser = firebase.auth().currentUser;
			if(!currentUser) throw new Error('กรุณาเข้าสู่ระบบใหม่');
			const token = await currentUser.getIdToken();
			const response = await axios.post(`${this.getPayBridgeApiBase()}/paybridge/deposit/check`, {
				localDepositId,
				amount: this.deposit_value,
				userKey: this.user.key,
				code: this.user.code,
				user: {
					code: this.user.code,
					firstname: this.user.firstname,
					lastname: this.user.lastname,
					bank: this.user.bank,
					account_no: this.user.account_no,
				},
			}, {
				timeout: 15000,
				headers: { Authorization: `Bearer ${token}` },
			});
			const result = response.data || {};
			this.paybridgeLocalDepositId = result.localDepositId || localDepositId;
			if(result.action === 'PAY_BRIDGE_RECIPIENT' && result.matchId && this.isPayBridgeBankAccount(result.recipientAccount)){
				this.paybridgeMatch = result;
				this.paybridgeFallback = false;
				this.persistPayBridgeTask();
			}else{
				this.paybridgeFallback = true;
				this.corepaypage = false;
				this.paybridgeMessage = '';
			}
		}catch(error){
			this.paybridgeLocalDepositId = '';
			this.paybridgeFallback = true;
			this.corepaypage = false;
			this.paybridgeMessage = '';
		}finally{
			this.paybridgeChecking = false;
			this.isProcessing = false;
			this.$store.commit('user/SET_LOADING', false);
		}
	},
	  async getBankDeposit(){
		setTimeout(async () => {
				this.bank = (await firebase.database().ref(`/bank/deposit`).once('value')).val() || {};
				this.corepayPaymentMode = this.normalizeCorepayPaymentMode(this.bank.corepayPaymentMode);
			if(this.bank.giveagetSlipEnabled === undefined) this.bank.giveagetSlipEnabled = false;
			if(this.bank.giveagetSlipUseTimeWindow === undefined) this.bank.giveagetSlipUseTimeWindow = false;
			if(!this.bank.giveagetSlipStartTime) this.bank.giveagetSlipStartTime = '23:00';
			if(!this.bank.giveagetSlipEndTime) this.bank.giveagetSlipEndTime = '02:00';
			if(this.bank.corepay){
				this.corepay = true;
				this.corepaymain = true;
			}else{
				this.corepay = false;
				this.corepaymain = false;
			}
			if(this.bank.papaya){
				this.papaya = true;
				this.papayamain = true;
			}else{
				this.papaya = false;
				this.papayamain = false;
			}
			if(this.bank.onepay){
				this.onepay = true;
				this.onepaymain = true;
			}else{
				this.onepay = false;
				this.onepaymain = false;
			}
			if(this.bank.coolpay){
				this.coolpay = true;
				this.coolpaymain = true;
			}else{
				this.coolpay = false;
				this.coolpaymain = false;
			}
			if(this.bank.nowpay){
				this.nowpay = true;
			}else{
				this.nowpay = false;
			}
			const userAccountNo = (this.user && this.user.account_no) ? this.user.account_no.toString().replace(/\D/g, '') : '';
			const accountLastDigit = userAccountNo.charAt(userAccountNo.length - 1);
			const isLowDepositUser = this.isLowDepositUser();
			if(isLowDepositUser){
				this.nowpay = false
				this.bank.kbank = undefined
				this.bank.scb = undefined
				this.bank.truewallet = undefined
			}else
			if(this.user && userAccountNo && this.bank.scb2 && this.bank.scb2.accountno && Number(userAccountNo) % 2 === 0){
				this.bank.scb = this.bank.scb2;
			}else if(this.user && this.bank.scb3 && this.bank.scb3.accountno && (accountLastDigit === '1' || accountLastDigit === '3')){
				this.bank.scb = this.bank.scb3;
			}
			if(this.bank.aha){
				this.aha = true;
				this.ahamain = true;
			}else{
				this.aha = false;
				this.ahamain = false;
			}
			if(this.bank.fynpay){
				this.fynpay = true;
				this.fynpaymain = true;
			}else{
				this.fynpay = false;
				this.fynpaymain = false;
			}
			if(this.bank.paymentmx){
				this.paymentmx = true;
				this.paymentmxmain = true;
			}else{
				this.paymentmx = false;
				this.paymentmxmain = false;
			}
			if(this.bank.giveaget){
				this.giveaget = true;
				this.giveagetmain = true;
			}else{
				this.giveaget = false;
				this.giveagetmain = false;
			}
			if(this.bank.bungpay){
				this.bungpay = true;
				this.bungpaymain = true;
			}else{
				this.bungpay = false;
				this.bungpaymain = false;
			}
			this.bungpayMode = this.bank.bungpayMode || 'QR';
			this.applyDepositAccountVisibilityRules();
			this.slipReading = this.canShowDepositBankAccounts() && !!this.bank.slipReading;
			this.customBanksList = this.canShowDepositBankAccounts() && this.bank.customBanks ? (Array.isArray(this.bank.customBanks) ? this.bank.customBanks : Object.values(this.bank.customBanks)) : [];
			this.paybridge = this.canShowDepositBankAccounts() && PAYBRIDGE_FRONTEND_ENABLED && this.isPayBridgeAllowedUser() && !this.isTrueWalletBank(this.user && this.user.bank) && (this.isLocalPayBridgeTestMode() || !!(this.bank.paybridge && this.bank.paybridge.enabled));
			this.prepareCorepayDeposit();
			if(this.paybridge && !this.paybridgeFallback && $('#depositModal').hasClass('show')){
				this.corepaypage = true;
			}
			if(!this.paybridge){
				this.paybridgeFallback = false;
				this.clearPayBridgeTask();
			}
		}, 1500);
	},
	isNumber(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 46) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
	checkLineLogin (data) {
		if(data.userId && this.user && this.user.key){
	  		firebase.database().ref(`users/${this.user.key}`).update({userId:data.userId,pictureUrl:data.pictureUrl});
			this.$swal({ icon: 'success', title: 'Line', text: 'เชื่อมต่อระบบ Line เรียบร้อยแล้วค่ะ' })
			const user = localStorage.getItem('userData');
			if(user){
				const _user = JSON.parse(user);
				this.$store.dispatch('user/setUser',_user).catch(err => { console.error(err) });
			}
		}
    },
	async getToken (code) {
      const data = qs.stringify({
        grant_type: 'authorization_code',
        code,
        redirect_uri: this.callbackUri,
        client_id: this.clientId,
        client_secret: this.clientSecret
      })
      let response
      await axios({
        method: 'post',
        url: 'https://api.line.me/oauth2/v2.1/token',
        data: data
      }).then(async res => {
        if (res.status !== 200) {
          this.error = 'โปรดติดต่อแอดมิน'
        } else if (res.data) {
          response = res.data
        }
      })
      return response
    },
	async getProfile (token) {
      return await axios.get('https://api.line.me/v2/profile', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    },
	lineLogin () {
      const url = 'https://access.line.me/oauth2/v2.1/authorize'
      let params = {
        response_type: 'code',
        client_id: this.clientId,
        redirect_uri: this.callbackUri,
        state: Math.random().toString(32).substring(2),
        scope: 'openid profile'
      }
      if (this.addFriend) {
        params = Object.assign(params, {
          prompt: 'consent',
          bot_prompt: 'aggressive'
        })
      }
      window.location.href = `${url}?${queryString.stringify(params)}`
    },
	async addLogin(user){
        await axios.get('https://api.ipify.org?format=json').then(x => {
          if(x.data.ip && user.key){
			axios({
				method: 'post',
				url: 'https://api.deltaplus-dp.com/api/addlogin',
				data: {
					key: user.key,
					ip: x.data.ip
				}
			})
          }
        });
        // await axios.get('https://checkip.amazonaws.com').then(x => {
        //   if(x){
        //     firebase.database().ref(`/users/${key}`).update({
        //       ip:x
        //     });
        //   }
        // });
	},
	nl2br (str, is_xhtml) {
		if (typeof str === 'undefined' || str === null) {
			return '';
		}
		var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
		return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
	},
	closePromotion(){
		this.$store.commit('user/SET_PROMOTION', [])
	},
	clipboardSuccessHandler () {
      this.$swal({ icon: 'success', title: 'Copy', text: 'คัดลอกเรียบร้อยแล้ว' })
    },
	gotoMain(){
		router.replace('/')
	},
	receivePromotion(){
		if(this.user && this.user.key){
			if(this.gotpro){
				this.$store.commit("user/SET_GOT_PRO", false);
				//firebase.database().ref(`users/${this.user.key}`).update({bonus:'N'});
				firebase.firestore().collection('users').doc(this.user.key).update({bonus:'N'});
			}else{
				this.$store.commit("user/SET_GOT_PRO", true);
				//firebase.database().ref(`users/${this.user.key}`).update({bonus:'Y'});
				firebase.firestore().collection('users').doc(this.user.key).update({bonus:'Y'});
			}
		}
	},
	getUserId(){
	  	const user = localStorage.getItem('userData');
		if(user){
			const _user = JSON.parse(user);
			return _user;
		}else{
			firebase.auth().signOut()
			localStorage.removeItem('userData')
			router.replace('/login')
		}
	},
	async moveCreditToWallet(){
		this.$store.commit('user/SET_LOADING', true)
		const user = this.getUserId();
		try {
        // Dispatch the action to move credit to wallet
			await this.$store.dispatch('user/moveCreditToWallet');
			
			// Wait for 2 seconds before proceeding
			//await new Promise(resolve => setTimeout(resolve, 2000));

			// Dispatch the action to get the last bonus
			await this.$store.dispatch('user/getLastBonus', user);

			if (this.lastbonus.turncredit) {
				this.$store.commit("user/SET_ALERT_WITHDRAWALL", true);
			}

			// Wait for an additional 2 seconds
			// Finally, stop the loading
			this.$store.commit('user/SET_LOADING', false);
		} catch (err) {
			console.error(err);
		}
		
		// this.$store.dispatch('user/moveCreditToWallet').finally(res => {
		// 	setTimeout(() => {
		// 		this.$store.dispatch('user/getLastBonus', user).finally(res => {
		// 			this.$store.commit('user/SET_LOADING', false)
		// 			if(this.lastbonus.turncredit){
		// 				this.$store.commit("user/SET_ALERT_WITHDRAWALL", true);
		// 			}
		// 		}).catch(err => { console.error(err) })
		// 	}, 1000);
		// }).catch(err => { console.error(err) })
	},
	async checkPromotions(){
	  this.$store.commit('user/SET_LOADING', true)
      this.$store.dispatch('user/checkPromotions').finally(res => { this.$store.commit('user/SET_LOADING', false) }).catch(err => { console.error(err) })
    },
	getBank(){
		if(this.user.bank){
			require(`../assets/images/${this.user.bank}.jpg`)
		}
	},
	numberWithCommas (x) {
	  if(!x) x = 0;
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
	numberWithCommas2 (x) {
	  if(!x) x = 0;
      return x.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  	},
	gotoPromotion(){
		$("#accountModal").modal('hide')
		router.replace('/promotion')
	},
	confirmLogout(){
      this.$swal({ icon: 'question', title: 'Log Out!', text: 'ยืนยันออกจากระบบ',showCancelButton: true,confirmButtonText: 'ตกลง'}).then((result) => {
		if (result.isConfirmed) {
			$("#accountModal").modal('hide')
			firebase.auth().signOut()
			localStorage.removeItem('userData')
			router.replace('/login')
		}
      })
    },
	setWithdraw (value) {
		  if (value === 'plus') {
			  this.withdraw = (this.withdraw) ? this.withdraw + 10 : 10
		  } else if (value === 'minus') {
			  if (this.withdraw) { this.withdraw = (this.withdraw) ? this.withdraw - 10 : 0 }
		  } else if (value > 0) { this.withdraw = value } else { this.withdraw = 0 }
	},
	rand () {
    	return Math.random().toString(36).substr(2); // remove `0.`
	},
	token () {
    	return this.rand() + this.rand(); // to make it longer
	},
	async withdrawConfirm () {
		if (this.withdrawSubmitting) return;
		this.withdrawSubmitting = true;
		try {
			await this.doWithdrawConfirm();
		} finally {
			this.withdrawSubmitting = false;
		}
	},
	async doWithdrawConfirm () {
		const user = this.getUserId();
		if (user) {
			if (this.withdraw && this.withdraw >= 200) {
				if (Number(this.withdraw) <= Number(this.user.credit)) {
					let check = false;
					await firebase.firestore().collection('history').where('userkey','==',user.key).where('status','==','กำลังดำเนินการ').where('type','==','ถอน').limit(1).get().then((result)=>{
						if(result.size){
							check = true;
						}
					});
					if(!check){
						// let total = 0;
						// await firebase.firestore().collection('history').where('userkey','==',user.key).where('status','==','ดำเนินการแล้ว').where('type','==','ถอน').where('createdate','>=',moment().tz('Asia/Bangkok').format('YYYY-MM-DD')+' 00:00:00').get().then((result)=>{
						// 	if(result.size >= 5){
						// 		check = true;
						// 	}
						// 	result.forEach((doc)=>{
						// 		total += Number(doc.data().qty);
						// 	})
						// });
						await axios({
							method: 'post',
							url: 'https://api.deltaplus-dp.com/quserwithdraw/userwithdraw',
							data: {
								key: user.key,
								tel: user.tel,
								token: this.token(),
								credit: Number(this.withdraw)
							}
						})
						this.$swal({ icon: 'success', title: 'ทำรายการถอน', text: 'เรียบร้อยแล้วกรุณารอเงินเข้าบัญชี' })
						$("#withdrawModal").modal('hide')
						
					}else{
						this.$swal({ icon: 'error', title: 'ทำรายการถอน', text: 'โปรดรออนุมัติรายการถอนก่อนหน้านี้' })
					}
				}else {
					this.$swal({ icon: 'error', title: 'Error!', text: 'โปรดตรวจสอบจำนวนเครดิต' })
				}
			}else{
				this.$swal({ icon: 'error', title: 'Error!', text: 'โปรดตรวจสอบจำนวนเครดิต' })
			}
		}
	},
    reloadBalance() {
      this.fa_spin = true;
	  const user = localStorage.getItem('userData');
	  if(user){
		  const _user = JSON.parse(user);
		  this.$store.dispatch('user/setUser',_user).finally(() => { 
			  setTimeout(() => {
				  this.fa_spin = false
			  }, 1000);
		  }).catch(err => { console.error(err) });
	  }else{
		firebase.auth().signOut()
		localStorage.removeItem('userData')
		router.replace('/login')
	  }
    },
	showTabAccount() {
      if(!this.accountOpen) this.accountOpen = true; else this.accountOpen = false;
    },
	async changePassword(){
		if(this.password && this.password1 && this.password2){
			if(this.password1.length<6){
				this.$swal({ icon: 'warning', title: 'Password', text: `โปรดระบุรหัสผ่านมากกว่า 6 หลักค่ะ`}).then((result) => {
				});
				return;
			}else if(this.password1 != this.password2){
				this.$swal({ icon: 'warning', title: 'Password', text: `โปรดตรวจสอบรหัสผ่านใหม่อีกครั้งค่ะ`}).then((result) => {
				});
				return;
			}
			const user = this.getUserId();
			firebase.auth().signInWithEmailAndPassword(user.tel.trim().toLowerCase() + '@deltaplus.com', this.password.trim()).then(async (res) => {
				if (res.user) {
					this.$store.commit('user/SET_LOADING', true)
					axios({
						method: 'post',
						url: 'https://api.deltaplus-dp.com/api/resetpassword',
						data: {
							key: user.key,
							password: this.password1
						}
					}).then(async (result)=>{
						if(result.data && result.data.status){
							await firebase.auth().signInWithEmailAndPassword(user.tel.trim().toLowerCase() + '@deltaplus.com', this.password1.trim()).then(async (res2) => {
								if (res2.user) {
									this.$swal({ icon: 'success', title: 'Password', text: `เปลี่ยนรหัสผ่านเรียบร้อยแล้วค่ะ`}).then((result) => {});
									this.password = '';
									this.password1 = '';
									this.password2 = '';
									this.$store.commit('user/SET_LOADING', false)
								}
							}).catch(() => {
							})
						}
					}).catch(()=>{
						this.$store.commit('user/SET_LOADING', false)
					})
				}
			}).catch(() => {
				this.$swal({ icon: 'warning', title: 'Password', text: `โปรดตรวจสอบรหัสผ่านเดิมค่ะ`}).then((result) => {
				});
			})
			// const password = (await firebase.database().ref(`/users/${user.key}/password`).once('value')).val();
			// if(password != this.password){
			// 	this.$swal({ icon: 'warning', title: 'Password', text: `โปรดตรวจสอบรหัสผ่านเดิมค่ะ`}).then((result) => {
			// 	});
			// 	return;
			// }
			// this.$store.commit('user/SET_LOADING', true)
			// axios({
			// 	method: 'post',
			// 	url: 'https://api.deltaplus-dp.com/api/resetpassword',
			// 	data: {
			// 		key: user.key,
			// 		password: this.password1
			// 	}
			// }).then(async (result)=>{
			// 	if(result.data && result.data.status){
			// 		await firebase.auth().signInWithEmailAndPassword(user.tel.trim().toLowerCase() + '@deltaplus.com', this.password1.trim()).then(async (res2) => {
			// 			if (res2.user) {
			// 				this.$swal({ icon: 'success', title: 'Password', text: `เปลี่ยนรหัสผ่านเรียบร้อยแล้วค่ะ`}).then((result) => {
			// 			});
			// 			}
			// 		}).catch(() => {
			// 		})
			// 	}
			// 	this.$store.commit('user/SET_LOADING', false)
			// }).catch(()=>{
			// 	this.$store.commit('user/SET_LOADING', false)
			// })
			$("#accountModalMobile").modal('hide')
			$("#accountModal").modal('hide')
		}
	}
  }
}
</script>
<style scoped>
.glow {
    color: #fff;
    text-align: center;
    -webkit-animation: glow 1s ease-in-out infinite alternate;
    -moz-animation: glow 1s ease-in-out infinite alternate;
    animation: glow 1s ease-in-out infinite alternate;
    }

    @-webkit-keyframes glow {
    from {
text-shadow: 0 0 5px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 5px #dbc47a, 0 0 5px #dbc47a, 0 0 5px #dbc47a;
    }
    
    to {
text-shadow: 0 0 5px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 5px #dbc47a, 0 0 5px #dbc47a, 0 0 5px #dbc47a;
    }
}
@media (max-width: 500px) { 
	.x-header #headerBrand .navbar-brand .-logo {
		width: 350px;
	}
}
.-balance-container .-user-balance .-inner-box-wrapper2 {
    position: relative;
    margin-right: 5px;
    margin-left: 15px;
    padding: 6px 24px 6px 0px;
    font-weight: 500;
    border-radius: 20px;
    color: #fff;
    text-align: right;
}
.x-logged .-profile-container .-btn-wrapper .-profile-name2 {
	font-family: 'Kanit', sans-serif;
    font-size: 1.2rem;
  /*  color: #e5e5e5; */
    font-weight: 200;
    margin-right: 2px;
    padding-left: 10px;
    color: #f9f9d6;
	text-align: center;
}
.x-logged .-profile-container .-btn-mobile-wrapper .-profile-name2 {
	font-family: 'Kanit', sans-serif;
    font-size: 1.1rem;
  /*  color: #e5e5e5; */
    font-weight: 200;
    margin-right: 2px;
    padding-left: 10px;
    color: #f9f9d6;
	text-align: center;
}

.-balance-container .-user-balance .-btn-balance2 {
    position: absolute;
    right: 10px;
    padding: 0;
    color: #FFFFFF;
    background: transparent;
    border: none;
}
.cCsozd {
    display: inline-block;
    padding: 0.5rem 1rem;
    height: 44px;
    font-size: 1em;
    line-height: 1.5;
    border: none;
    border-radius: 0.25rem;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
}
.ewHin {
    background: rgb(0, 187, 0);
    color: rgb(255, 255, 255);
    height: 50px;
    min-width: 180px;
    border-radius: 25px;
    padding-left: 34px;
    padding-right: 34px;
}
.ewHin .icon {
    height: 18px;
    margin: 0px 0.5rem;
    vertical-align: sub;
    border: 0px;
}



.mid {
  display: flex;
  align-items: center;
  justify-content: center;
}


/* Switch starts here */
.rocker {
  display: inline-block;
  position: relative;
  /*
  SIZE OF SWITCH
  ==============
  All sizes are in em - therefore
  changing the font-size here
  will change the size of the switch.
  See .rocker-small below as example.
  */
  font-size: 1em;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  color: #888;
  width: 7em;
  height: 4em;
  overflow: hidden;
  border-bottom: 0.5em solid #eee;
}

.rocker-small {
  font-size: 0.75em; /* Sizes the switch */
  margin: 1em;
}

.rocker::before {
  content: "";
  position: absolute;
  top: 0.5em;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #999;
  border: 0.5em solid #eee;
  border-bottom: 0;
}

.rocker input {
  opacity: 0;
  width: 0;
  height: 0;
}

.switch-left,
.switch-right {
  cursor: pointer;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5em;
  width: 3em;
  transition: 0.2s;
}

.switch-left {
  height: 2.4em;
  width: 2.75em;
  left: 0.85em;
  bottom: 0.4em;
  background-color: #ddd;
  transform: rotate(15deg) skewX(15deg);
}

.switch-right {
  right: 0.5em;
  bottom: 0;
  background-color: #bd5757;
  color: #fff;
}

.switch-left::before,
.switch-right::before {
  content: "";
  position: absolute;
  width: 0.4em;
  height: 2.45em;
  bottom: -0.45em;
  background-color: #ccc;
  transform: skewY(-65deg);
}

.switch-left::before {
  left: -0.4em;
}

.switch-right::before {
  right: -0.375em;
  background-color: transparent;
  transform: skewY(65deg);
}

input:checked + .switch-left {
  background-color: #0084d0;
  color: #fff;
  bottom: 0px;
  left: 0.5em;
  height: 2.5em;
  width: 3em;
  transform: rotate(0deg) skewX(0deg);
}

input:checked + .switch-left::before {
  background-color: transparent;
  width: 3.0833em;
}

input:checked + .switch-left + .switch-right {
  background-color: #ddd;
  color: #888;
  bottom: 0.4em;
  right: 0.8em;
  height: 2.4em;
  width: 2.75em;
  transform: rotate(-15deg) skewX(-15deg);
}

input:checked + .switch-left + .switch-right::before {
  background-color: #ccc;
}

/* Keyboard Users */
input:focus + .switch-left {
  color: #333;
}

input:checked:focus + .switch-left {
  color: #fff;
}

input:focus + .switch-left + .switch-right {
  color: #fff;
}

input:checked:focus + .switch-left + .switch-right {
  color: #333;
}
#my_file {
    display: none;
}

/* Bank Transfer Display Styles */
.bank-display-container {
    padding: 10px;
    max-width: 380px;
    margin: 0 auto;
}

.bank-card {
    background: linear-gradient(145deg, #667eea 0%, #764ba2 50%, #6B8DD6 100%);
    border-radius: 20px;
    padding: 25px 20px;
    box-shadow: 0 10px 40px rgba(102, 126, 234, 0.4);
    color: #fff;
    position: relative;
    overflow: hidden;
}

.bank-card::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -50%;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
    pointer-events: none;
}

.bank-image-wrapper {
    text-align: center;
    margin-bottom: 20px;
}

.bank-image {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    object-fit: cover;
    border: 4px solid rgba(255, 255, 255, 0.9);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
    background: #fff;
}

.account-info {
    text-align: center;
}

.amount-section {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    border-radius: 16px;
    padding: 18px;
    margin-bottom: 18px;
    border: 1px solid rgba(255, 255, 255, 0.3);
}

.amount-label {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.95);
    margin-bottom: 10px;
    font-weight: 500;
}

.amount-value {
    font-size: 1.8rem;
    font-weight: 700;
    color: #fff;
    cursor: pointer;
    padding: 8px 16px;
    border-radius: 12px;
    transition: all 0.3s ease;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    display: inline-block;
}

.amount-value:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: scale(1.02);
}

.amount-warning {
    margin-top: 12px;
    font-size: 0.72rem;
    color: #ffe066;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 6px;
    line-height: 1.4;
    padding: 0 10px;
}

.account-name-section {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 12px;
    padding: 12px 15px;
    margin-bottom: 18px;
}

.account-name {
    font-size: 1rem;
    font-weight: 600;
    color: #fff;
    margin-top: 6px;
    word-break: break-word;
}

.account-number {
    font-size: 1.4rem;
    font-weight: 700;
    letter-spacing: 3px;
    color: #fff;
    cursor: pointer;
    padding: 12px 20px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    display: inline-block;
    margin: 10px 0;
    transition: all 0.3s ease;
    border: 2px solid rgba(255, 255, 255, 0.3);
}

.account-number:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.02);
}

.copy-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);
    color: #fff;
    border: none;
    border-radius: 25px;
    padding: 12px 24px;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-top: 12px;
    box-shadow: 0 4px 15px rgba(0, 176, 155, 0.3);
}

.copy-button:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(0, 176, 155, 0.5);
}

.copy-amount-button {
    background: linear-gradient(135deg, #ff6b6b 0%, #feca57 100%);
    box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
}

.copy-amount-button:hover {
    box-shadow: 0 6px 20px rgba(255, 107, 107, 0.5);
}

/* Mobile Scroll Fix for Bank Transfer Display */
#depositModal .modal-body.-modal-body {
    max-height: 85vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

#depositModal .-top {
    max-height: calc(85vh - 60px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 20px;
}

/* Ensure bank display is fully visible */
@media (max-width: 768px) {
    .bank-display-container {
        padding: 8px;
        margin-top: 10px;
    }

    .bank-card {
        padding: 18px 15px;
    }

    .bank-image {
        width: 70px;
        height: 70px;
    }

    .amount-value {
        font-size: 1.5rem;
    }

    .account-number {
        font-size: 1.2rem;
        letter-spacing: 2px;
        padding: 10px 15px;
    }

    .copy-button {
        padding: 10px 18px;
        font-size: 0.85rem;
    }
}

@media (max-height: 700px) {
    #depositModal .modal-body.-modal-body {
        max-height: 80vh;
    }

    #depositModal .-top {
        max-height: calc(80vh - 50px);
    }

    .bank-image-wrapper {
        margin-bottom: 12px;
    }

    .bank-image {
        width: 60px;
        height: 60px;
    }

    .amount-section {
        padding: 12px;
        margin-bottom: 12px;
    }

    .account-name-section {
        padding: 10px 12px;
        margin-bottom: 12px;
    }
}

/* PayBridge task button */
.paybridge-task-entrance{position:absolute;right:0;top:210px;z-index:6;margin-right:-14px;}
.paybridge-task-button { width: 154px; border: 2px solid rgba(255,255,255,.8); border-radius: 18px 0 0 18px; background: linear-gradient(135deg, #f97316 0%, #dc2626 100%); color: #fff; padding: 9px 11px; display: grid; grid-template-columns: 14px 1fr; align-items: center; gap: 8px; box-shadow: 0 12px 28px rgba(127, 29, 29, .34); cursor: pointer; animation: paybridgeTaskPulse 1.4s ease-in-out infinite; }
.paybridge-task-dot { width: 12px; height: 12px; border-radius: 999px; background: #fde047; box-shadow: 0 0 0 0 rgba(253, 224, 71, .75); animation: paybridgeTaskDot 1.4s ease-in-out infinite; }
.paybridge-task-copy { display: flex; flex-direction: column; align-items: flex-start; line-height: 1.1; text-align: left; }
.paybridge-task-copy strong { font-size: .92rem; font-weight: 900; }
.paybridge-task-copy small { color: #fff7ed; font-size: .75rem; font-weight: 800; }
@keyframes paybridgeTaskPulse { 0%, 100% { transform: translateX(0); } 50% { transform: translateX(-3px); } }
@keyframes paybridgeTaskDot { 0% { box-shadow: 0 0 0 0 rgba(253, 224, 71, .75); } 80%, 100% { box-shadow: 0 0 0 10px rgba(253, 224, 71, 0); } }
@media (max-width: 575.98px) {
  .paybridge-task-button { width: 148px; padding: 8px 10px; }
  .paybridge-task-copy strong { font-size: .88rem; }
  .paybridge-task-copy small { font-size: .72rem; }
}

/* PayBridge deposit display */
#depositModal .paybridge-modal-shell { background: linear-gradient(180deg, rgba(250,254,255,.97), rgba(231,248,255,.95)) !important; border-color: rgba(255,255,255,.88) !important; box-shadow: 0 28px 74px rgba(0,18,28,.38), inset 0 0 0 1px rgba(255,255,255,.78) !important; }
#depositModal .paybridge-modal-shell .-fake-bg-top-wrapper { background: linear-gradient(135deg, #07384f, #0b83a1 48%, #1267d6) !important; box-shadow: none !important; }
#depositModal .paybridge-modal-shell .x-title-modal { color: #fff !important; text-shadow: none !important; }
.paybridge-panel { width: min(100%, 620px); margin: 0 auto 10px; padding: 16px; color: #0c2130; background: rgba(255,255,255,.82); border: 1px solid rgba(255,255,255,.88); border-radius: 24px; box-shadow: 0 16px 42px rgba(6,54,79,.15); position: relative; overflow: hidden; }
.paybridge-panel:before { content: ""; position: absolute; inset: 0; padding: 2px; border-radius: 24px; background: linear-gradient(120deg, rgba(255,255,255,.2), rgba(255,255,255,.96), rgba(245,184,51,.96), rgba(255,255,255,.18), rgba(245,184,51,.82), rgba(255,255,255,.2)); background-size: 240% 240%; -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0); -webkit-mask-composite: xor; mask-composite: exclude; pointer-events: none; animation: paybridgeBorderRun 4.6s linear infinite; z-index: 2; }
.paybridge-panel:after { content: ""; position: absolute; left: 18px; right: 18px; top: 0; height: 1px; background: linear-gradient(90deg, transparent, rgba(255,255,255,.94), rgba(245,184,51,.94), transparent); box-shadow: 0 0 18px rgba(245,184,51,.55); animation: paybridgeTopGlint 2.8s ease-in-out infinite; z-index: 3; }
@keyframes paybridgeBorderRun { 0% { background-position: 0% 50%; } 100% { background-position: 240% 50%; } }
@keyframes paybridgeTopGlint { 0%,100% { opacity:.28; transform: scaleX(.72); } 50% { opacity:.98; transform: scaleX(1); } }
.paybridge-panel-header { text-align: center; background: linear-gradient(180deg, rgba(255,255,255,.98), rgba(237,250,255,.94)); border: 1px solid rgba(16,199,232,.16); border-radius: 18px; padding: 16px 16px 14px; box-shadow: 0 10px 26px rgba(13,82,110,.10); }
.paybridge-badge { display: inline-flex; align-items: center; justify-content: center; gap: 9px; height: 36px; padding: 0 15px; border-radius: 999px; background: linear-gradient(135deg, #052f48, #087f9b); color: #e9fbff; font-weight: 950; font-size: .88rem; box-shadow: 0 14px 24px rgba(6,58,82,.26); }
.paybridge-mark { width: 18px; height: 18px; display: inline-block; border-radius: 7px; background: linear-gradient(135deg, rgba(255,255,255,.85), transparent 42%), linear-gradient(135deg, #f5b833, #10c7e8); box-shadow: 0 0 16px rgba(16,199,232,.58); }
.paybridge-panel-header h3 { margin: 12px 0 5px; color: #0c2130; font-size: 1.45rem; font-weight: 950; line-height: 1.22; }
.paybridge-panel-header p { margin: 0; color: #607684; font-size: .95rem; line-height: 1.45; font-weight: 800; }
.paybridge-route { width: min(280px, 100%); margin: 13px auto 0; display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; color: #0b5c72; font-size: 10px; font-weight: 950; text-transform: uppercase; }
.paybridge-route span { min-height: 24px; display: grid; place-items: center; border-radius: 999px; background: #e8fbff; border: 1px solid #b8eef8; }
.paybridge-agreement-card { display: grid; gap: 12px; margin-top: 14px; padding: 0; background: transparent; color: #0c2130; text-align: left; }
.paybridge-agreement-list { display: grid; gap: 12px; margin: 0; }
.paybridge-agreement-item { display: grid; grid-template-columns: 60px 1fr; align-items: center; gap: 14px; min-height: 82px; padding: 14px 15px; border-radius: 20px; border: 1px solid; position: relative; overflow: hidden; }
.paybridge-agreement-item:after { content: ""; position: absolute; inset: auto 14px 0 88px; height: 1px; background: linear-gradient(90deg, currentColor, transparent); opacity: .18; }
.paybridge-agreement-item.-one { color: #745000; background: linear-gradient(135deg, #fff7d9, #fffdf6); border-color: #ffd66e; }
.paybridge-agreement-item.-two { color: #075d78; background: linear-gradient(135deg, #e8fbff, #fff); border-color: #b8eef8; }
.paybridge-agreement-item.-three { color: #076346; background: linear-gradient(135deg, #e9fff5, #fff); border-color: #bcefd8; }
.paybridge-agreement-item > strong { width: 60px; height: 60px; display: grid; place-items: center; border-radius: 20px; color: #fff; font-size: 31px; font-weight: 1000; box-shadow: 0 12px 20px rgba(0,24,36,.14); }
.paybridge-agreement-item.-one > strong { background: linear-gradient(135deg, #f5b833, #d98600); }
.paybridge-agreement-item.-two > strong { background: linear-gradient(135deg, #10c7e8, #1677ff); }
.paybridge-agreement-item.-three > strong { background: linear-gradient(135deg, #12b981, #07886e); }
.paybridge-agreement-item b { display: block; color: #0c2130; font-size: 1rem; line-height: 1.3; font-weight: 950; }
.paybridge-agreement-item small { display: block; margin-top: 2px; color: currentColor; font-size: .84rem; line-height: 1.35; font-weight: 850; }
.paybridge-agreement-final { margin: 0; padding: 11px 12px; border-radius: 16px; color: #8d2b33; background: linear-gradient(135deg, #fff2f3, #fff8f9); border: 1px solid #ffcdd4; font-size: .88rem; line-height: 1.45; font-weight: 900; text-align: center; }
.paybridge-ack-button, .paybridge-upload-button { width: 100%; min-height: 58px; border: none; border-radius: 18px; background: linear-gradient(135deg, rgba(255,255,255,.18), transparent 42%), linear-gradient(135deg, #0fb879, #087e63); color: #fff; display: inline-flex; align-items: center; justify-content: center; gap: 10px; font-size: 1.04rem; font-weight: 1000; box-shadow: 0 16px 30px rgba(8,126,99,.30), inset 0 0 0 1px rgba(255,255,255,.16); cursor: pointer; transition: transform .15s ease, box-shadow .15s ease; }
.paybridge-ack-button:hover, .paybridge-upload-button:hover { transform: translateY(-1px); box-shadow: 0 18px 34px rgba(8,126,99,.36); }
.paybridge-cancel-button { width: 100%; min-height: 46px; margin-top: 10px; border-radius: 14px; border: 1px solid #ffd4da; background: #fff4f5; color: #b91c1c; display: inline-flex; align-items: center; justify-content: center; gap: 8px; font-size: .95rem; font-weight: 900; cursor: pointer; }
.paybridge-cancel-button.-after-account { background: #fff4f5; color: #b91c1c; border-color: #ffd4da; box-shadow: 0 8px 18px rgba(185,28,28,.10); }
.paybridge-amount-card { margin: 14px 0; border-radius: 21px; background: linear-gradient(135deg, rgba(255,255,255,.16), transparent 42%), linear-gradient(135deg, #052f48, #1267d6); color: #fff; padding: 15px; display: grid; grid-template-columns: 1fr auto; align-items: center; gap: 12px; box-shadow: 0 15px 30px rgba(18,103,214,.25); }
.paybridge-amount-card span { display: block; color: rgba(255,255,255,.76); font-size: .8rem; font-weight: 850; }
.paybridge-amount-card strong { display: flex; align-items: center; gap: 8px; margin-top: 2px; font-size: 1.55rem; line-height: 1.05; font-weight: 1000; white-space: nowrap; }
.paybridge-timer { min-width: 80px; height: 46px; display: grid; place-items: center; border-radius: 16px; color: #07354f; background: #eafdff; border: 1px solid rgba(255,255,255,.68); font-variant-numeric: tabular-nums; font-size: .95rem; font-weight: 1000; box-shadow: 0 0 0 4px rgba(16,199,232,.12); animation: paybridgeTimerPulse 1.18s ease-in-out infinite; }
@keyframes paybridgeTimerPulse { 0%,100% { background:#eafdff; box-shadow:0 0 0 4px rgba(16,199,232,.12), 0 0 0 0 rgba(245,184,51,0); transform:scale(1); } 42% { background:#fff1b8; box-shadow:0 0 0 4px rgba(245,184,51,.18), 0 0 0 9px rgba(245,184,51,.16); transform:scale(1.035); } 58% { background:#fff8dc; box-shadow:0 0 0 4px rgba(245,184,51,.15), 0 0 0 3px rgba(245,184,51,.10); transform:scale(1.01); } }
.paybridge-account-card { display: grid; grid-template-columns: 64px 1fr; align-items: center; gap: 13px; padding: 15px; border-radius: 21px; background: #fff; box-shadow: 0 14px 30px rgba(6,54,79,.12); border: 1px solid rgba(16,199,232,.22); position: relative; overflow: hidden; }
.paybridge-account-card:before { content: ""; position: absolute; left: 15px; right: 15px; top: 0; height: 1px; background: linear-gradient(90deg, transparent, rgba(16,199,232,.86), transparent); }
.paybridge-bank-mark { width: 64px; height: 64px; padding: 8px; border-radius: 19px; background: #f5fbfd; display: flex; align-items: center; justify-content: center; border: 1px solid #dff1f7; }
.paybridge-bank-mark img { width: 100%; height: 100%; object-fit: contain; border-radius: 12px; }
.paybridge-account-detail { min-width: 0; display: flex; flex-direction: column; align-items: flex-start; }
.paybridge-bank-name { color: #607684; font-size: .78rem; font-weight: 900; text-transform: uppercase; }
.paybridge-account-name { color: #0c2130; font-size: 1rem; font-weight: 950; line-height: 1.25; word-break: break-word; }
.paybridge-account-number { margin-top: 5px; display: flex; align-items: center; gap: 8px; color: #087f8f; font-size: 1.42rem; line-height: 1.1; font-weight: 1000; letter-spacing: 0; word-break: break-all; font-variant-numeric: tabular-nums; }
.paybridge-icon-copy { flex: 0 0 auto; width: 34px; height: 34px; display: inline-grid; place-items: center; border-radius: 12px; color: currentColor; background: rgba(255,255,255,.20); border: 1px solid rgba(255,255,255,.54); box-shadow: 0 8px 16px rgba(3,30,48,.12); }
.paybridge-account-number .paybridge-icon-copy { color: #075a74; background: #e8fbff; border-color: #bcebf5; }
.paybridge-critical-warning { margin-top: 14px; padding: 11px; display: grid; grid-template-columns: 30px 1fr; align-items: start; gap: 10px; border-radius: 17px; background: #fff4f5; color: #8d2b33; border: 1px solid #ffd4da; box-shadow: none; }
.paybridge-warning-icon { width: 28px; height: 28px; border-radius: 11px; display: flex; align-items: center; justify-content: center; background: #d84a4f; color: #fff; font-size: .95rem; }
.paybridge-warning-copy { display: flex; flex-direction: column; align-items: flex-start; text-align: left; gap: 3px; }
.paybridge-warning-copy span { font-size: .88rem; font-weight: 850; line-height: 1.45; }
.paybridge-slip-actions { margin-top: 16px; }
.paybridge-file-input { display: none; }
@media (max-width: 575.98px) {
  .paybridge-panel { padding: 10px; border-radius: 22px; }
  .paybridge-panel-header h3 { font-size: 1.28rem; }
  .paybridge-panel-header p { font-size: .96rem; }
  .paybridge-route { gap: 5px; font-size: 9px; }
  .paybridge-agreement-item { grid-template-columns: 54px 1fr; gap: 12px; min-height: 76px; padding: 12px; }
  .paybridge-agreement-item > strong { width: 54px; height: 54px; font-size: 28px; }
  .paybridge-agreement-item b { font-size: .96rem; }
  .paybridge-agreement-final { font-size: .86rem; }
  .paybridge-ack-button { min-height: 62px; font-size: 1.1rem; }
  .paybridge-cancel-button { min-height: 50px; font-size: 1rem; }
  .paybridge-amount-card { grid-template-columns: 1fr; }
  .paybridge-amount-card strong { align-items: flex-start; font-size: 1.34rem; }
  .paybridge-timer { width: 80px; }
  .paybridge-account-card { grid-template-columns: 56px 1fr; gap: 10px; padding: 12px; }
  .paybridge-bank-mark { width: 56px; height: 56px; border-radius: 16px; }
  .paybridge-account-number { align-items: flex-start; font-size: 1.2rem; }
}

.paybridge-customer-warning {
  margin: 0 0 16px;
  padding: 14px;
  border-radius: 16px;
  background: linear-gradient(135deg, #7f1d1d 0%, #b91c1c 58%, #f97316 100%);
  color: #fff;
  border: 2px solid rgba(255,255,255,.38);
  box-shadow: 0 16px 34px rgba(127,29,29,.32), inset 0 0 0 1px rgba(255,255,255,.12);
  text-align: left;
}
.paybridge-customer-warning-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}
.paybridge-customer-warning-head span {
  font-size: 1.05rem;
  font-weight: 1000;
  line-height: 1.2;
}
.paybridge-customer-warning-head strong {
  flex: 0 0 auto;
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  border-radius: 999px;
  background: #fff;
  color: #991b1b;
  font-size: .9rem;
  font-weight: 1000;
  font-variant-numeric: tabular-nums;
}
.paybridge-customer-warning-grid {
  display: grid;
  gap: 8px;
}
.paybridge-customer-warning-item {
  display: grid;
  grid-template-columns: 30px 1fr;
  gap: 9px;
  align-items: start;
  padding: 10px;
  border-radius: 13px;
  background: rgba(255,255,255,.13);
  border: 1px solid rgba(255,255,255,.18);
}
.paybridge-warning-no {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  background: #fff;
  color: #b91c1c;
  font-size: .95rem;
  font-weight: 1000;
}
.paybridge-customer-warning-item b {
  display: block;
  color: #fff;
  font-size: .94rem;
  line-height: 1.25;
  font-weight: 1000;
}
.paybridge-customer-warning-item small {
  display: block;
  margin-top: 2px;
  color: #fff7ed;
  font-size: .8rem;
  line-height: 1.35;
  font-weight: 800;
}
.paybridge-customer-warning-footer {
  margin-top: 10px;
  padding: 9px 10px;
  border-radius: 12px;
  background: rgba(255,255,255,.95);
  color: #991b1b;
  text-align: center;
  font-size: .85rem;
  line-height: 1.35;
  font-weight: 1000;
}
@media (max-width: 575.98px) {
  .paybridge-customer-warning {
    padding: 12px;
    border-radius: 15px;
  }
  .paybridge-customer-warning-head {
    align-items: stretch;
    flex-direction: column;
    gap: 7px;
  }
  .paybridge-customer-warning-head strong {
    width: 100%;
  }
  .paybridge-customer-warning-item {
    grid-template-columns: 28px 1fr;
    padding: 9px;
  }
  .paybridge-warning-no {
    width: 28px;
    height: 28px;
  }
}

</style>
<style lang="scss" scoped>
.modal-window {
  position: fixed;
  background-color: rgba(255, 255, 255, 0.25);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s;
  
  &:target {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }
  & > div {
    width: 300px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 1em;
    background: black;
	border: 4px solid #1e1eff;
  	border-radius: 30px;
  }
  header {
    font-weight: bold;
  }
  h1 {
    font-size: 150%;
    margin: 0 0 15px;
  }
}

.modal-close {
  color: #aaa;
  line-height: 50px;
  font-size: 80%;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  width: 70px;
  text-decoration: none;
  &:hover {
    color: black;
  }
}

/* Demo Styles */
.modal-window {
  & > div {
    border-radius: 1rem;
  }
}

.modal-window div:not(:last-of-type) {
  margin-bottom: 15px;
}

small {
  color: lightgray;
}

.tags {
  list-style: none;
  margin: 0;
  overflow: hidden; 
  padding: 0;
}



.tag {
  background: #eee;
  border-radius: 3px 0 0 3px;
  color: #999;
  display: inline-block;
  height: 26px;
  line-height: 26px;
  padding: 0 20px 0 23px;
  position: relative;
  margin: 0 10px 10px 0;
  text-decoration: none;
  -webkit-transition: color 0.2s;
}

.tag::before {
  border-radius: 10px;
  box-shadow: inset 0 1px rgba(0, 0, 0, 0.25);
  content: '';
  height: 6px;
  left: 10px;
  position: absolute;
  width: 6px;
  top: 10px;
}

.tag::after {
  background: #381D83;
  border-bottom: 13px solid transparent;
  border-left: 10px solid #eee;
  border-top: 13px solid transparent;
  content: '';
  position: absolute;
  right: 0;
  top: 0;
}

.tag:hover {
  background-color: #381D83;
  color: white;
}

.tag:hover::after {
   border-left-color: #381D83; 
}



.tag2 {
  background: #eee;
  border-radius: 3px 0 0 3px;
  color: #999;
  display: inline-block;
  height: 26px;
  line-height: 26px;
  padding: 0 20px 0 23px;
  position: relative;
  margin: 0 10px 10px 0;
  text-decoration: none;
  -webkit-transition: color 0.2s;
}

.tag2::before {
  border-radius: 10px;
  box-shadow: inset 0 1px rgba(0, 0, 0, 0.25);
  content: '';
  height: 6px;
  left: 10px;
  position: absolute;
  width: 6px;
  top: 10px;
}

.tag2::after {
  background: #381D83;
  border-bottom: 13px solid transparent;
  border-left: 10px solid #eee;
  border-top: 13px solid transparent;
  content: '';
  position: absolute;
  right: 0;
  top: 0;
}

.tag2:hover {
  background-color: #381D83;
  color: white;
}

.tag2:hover::after {
   border-left-color: #381D83; 
}
.x-ranking-entrance{position:absolute;right:0;top:150px;z-index:6;margin-right: -14px;}
@media (max-width:1199.98px){
	.x-ranking-entrance{/*position:relative;top:unset;z-index:unset;display:flex*/}
}
.x-ranking-entrance .-link-wrapper{
	background-color:rgba(0,0,0,.5);border-top-left-radius:20px;border-bottom-left-radius:20px;display:flex;padding:.4rem .75rem;color:#fff;align-items: center;
}
@media (min-width:1200px){
	.x-ranking-entrance .-link-wrapper:hover{text-decoration:none;background-color:rgba(0,0,0,.4)}
}@media (max-width:1199.98px){
	.x-ranking-entrance .-link-wrapper{padding:5px;margin-right:.5rem}
}@media (max-width:575.98px){
	.x-ranking-entrance .-link-wrapper{margin-right:.25rem}
}
.x-ranking-entrance .-link-wrapper .-image-wrapper{
	align-items:center;display:flex
}
.x-ranking-entrance .-link-wrapper .-image-wrapper .-ic-right-star-rank{width:30px}
@media (max-width:370px){
	.x-ranking-entrance .-link-wrapper .-image-wrapper .-ic-right-star-rank{min-width:25px}
}
.x-ranking-entrance .-link-wrapper .-text-wrapper{
	line-height:16px;font-size:1.1rem;margin-left:.5rem;
	display: block;
}

/* PaymentMX QR Code Styles */
.paymentmx-qr-container {
	padding: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.qr-card {
	background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
	border-radius: 24px;
	padding: 30px;
	box-shadow: 0 15px 40px rgba(30, 60, 114, 0.4);
	width: 100%;
	max-width: 400px;
	position: relative;
	overflow: hidden;
}

.qr-card::before {
	content: '';
	position: absolute;
	top: -100%;
	left: -100%;
	width: 300%;
	height: 300%;
	background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 50%);
	animation: qrShimmer 4s infinite ease-in-out;
}

@keyframes qrShimmer {
	0%, 100% { transform: translate(-10%, -10%); opacity: 0.3; }
	50% { transform: translate(10%, 10%); opacity: 0.6; }
}

.qr-header {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	color: #ffffff;
	font-size: 18px;
	font-weight: 700;
	margin-bottom: 20px;
	text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
	position: relative;
	z-index: 1;
}

.qr-header i {
	font-size: 24px;
	animation: qrPulse 2s ease-in-out infinite;
}

@keyframes qrPulse {
	0%, 100% { transform: scale(1); }
	50% { transform: scale(1.1); }
}

.qr-wrapper {
	background: #ffffff;
	border-radius: 16px;
	padding: 20px;
	box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	z-index: 1;
	margin-bottom: 20px;
}

.qr-image {
	width: 100%;
	max-width: 280px;
	height: auto;
	border-radius: 8px;
	transition: transform 0.3s ease;
}

.qr-image:hover {
	transform: scale(1.02);
}

.qr-amount {
	background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
	border-radius: 12px;
	padding: 15px 20px;
	text-align: center;
	margin-bottom: 20px;
	box-shadow: 0 6px 20px rgba(245, 87, 108, 0.3);
	position: relative;
	z-index: 1;
}

.qr-amount .amount-text {
	color: #ffffff;
	font-size: 18px;
	text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.qr-amount .amount-text strong {
	font-size: 22px;
	font-weight: 800;
}

.qr-instructions {
	background: rgba(255, 255, 255, 0.95);
	border-radius: 12px;
	padding: 20px;
	position: relative;
	z-index: 1;
}

.qr-instructions p {
	display: flex;
	align-items: center;
	gap: 12px;
	color: #2d3748;
	font-size: 14px;
	margin: 0;
	padding: 10px 0;
	border-bottom: 1px solid rgba(102, 126, 234, 0.1);
}

.qr-instructions p:last-child {
	border-bottom: none;
}

.qr-instructions i {
	color: #667eea;
	font-size: 18px;
	width: 24px;
	text-align: center;
}

/* Responsive Design for QR Code */
@media (max-width: 768px) {
	.paymentmx-qr-container {
		padding: 15px;
	}
	
	.qr-card {
		padding: 20px;
	}
	
	.qr-header {
		font-size: 16px;
	}
	
	.qr-wrapper {
		padding: 15px;
	}
	
	.qr-image {
		max-width: 220px;
	}
	
	.qr-amount .amount-text {
		font-size: 16px;
	}
	
	.qr-amount .amount-text strong {
		font-size: 20px;
	}
	
	.qr-instructions p {
		font-size: 13px;
	}
}

@media (max-width: 480px) {
	.qr-card {
		padding: 15px;
		border-radius: 18px;
	}
	
	.qr-header {
		font-size: 14px;
		margin-bottom: 15px;
	}
	
	.qr-header i {
		font-size: 20px;
	}
	
	.qr-wrapper {
		padding: 12px;
		border-radius: 12px;
	}
	
	.qr-image {
		max-width: 180px;
	}
	
	.qr-amount {
		padding: 12px 16px;
		margin-bottom: 15px;
	}
	
	.qr-amount .amount-text {
		font-size: 14px;
	}
	
	.qr-amount .amount-text strong {
		font-size: 18px;
	}
	
	.qr-instructions {
		padding: 15px;
	}
	
	.qr-instructions p {
		font-size: 12px;
		padding: 8px 0;
		gap: 10px;
	}
	
	.qr-instructions i {
		font-size: 16px;
		width: 20px;
	}
}
</style>
